import { useEffect, useState } from "react";
import Header from "../commun/Header";
import FooterPartenerCommun from '../commun/FooterPartenerCommun'

export default function Speakers(){
    
    const [speaker, setSpeaker] = useState(null);
    const [loading, setLoading] = useState(true);
    
    useEffect(()=>{
        setTimeout(()=>{
            setLoading(false);
        }, 1400);
    },[]);
    
    const [speakers, setSpeakers] = useState([
        {
            index: 2,
            name: `JOSÉ ANTONIO ÁLVAREZ`,
            description: `José Antonio Álvarez
is
the
vice
-
chair
of
the
board
of
directors
of
Grupo
Santander.
He
also
serves
as
vice
-
chair
of
Banco
Santander
(Brasil),
PagoNxt
and
AON
plc.
Mr
Á
lvarez
was
Group
CEO
until
2022.
Prior,
he
had
directed
Group
’
s
Finance
Division
from
2002
to
2004
and
acted
as
Group
CFO
until
2015.
Before
joining
Santander,
he
had
directed
the
finance
division
at
Argentaria
(1995
-
1999)
and
then
BBVA
(1999
-
2002),
served
as
CFO
at
Banco
Hipotecari
o
de
Espa
ñ
a
and
as
Vice
-
President
of
Finanpostal
Gesti
ón
Fondos
de
Inversió
n
y
Pensiones,
and
worked
at
Banco
de
Cr
é
dito
Industrial
and
Instituto
Nacional
de
Industria.
Mr
Á
lvarez
has
sat
on
the
boards
of
directors
of
Santander
Consumer
Finance
S.A,
Santa
nder
Consumer
Bank
AG,
Banco
de
Cr
é
dito
Local
S.A.
and
others,
and
on
the
supervisory
boards
of
Grupo
Santander
’
s
autonomous
subsidiaries
in
Poland,
Germany
and
the
US.
He
was
also
chairman
of
the
European
Banking
Federation
Banking
Supervision
Committee
f
rom
2009
to
2012.
Mr
Á
lvarez
holds
a
bachelor
’
s
degree
in
Economics
and
Business
from
the
University
of
Santiago
de
Compostela,
and
an
MBA
from
the
University
of
Chicago.`},
{
    index: 1,
    name: `JOSÉ MARÍA ÁLVAREZ - PALLETE`,
    description: `<p>Mr.
Álvarez
-
Pallete
joined
the
Telefónica
Group
in
1999
as
a
General
Manager
of
Finance
for
Telefónica
Internacional,
and
later
that
year
he
became
Chief
Financial
Officer
of
Telefónica
S.A.
In
2002
he
was
appointed
Executive
Chairman
of
Telefónica
Internacional.
Between
2006
and
2
011
he
was
Managing
Director
of
Telefónica
Latinoamérica.
He
was
appointed
Chairman
and
CEO
of
Telefónica
Europe
in
2011,
and
Chief
Operating
Officer
of
Telefónica,
S.A.
in
2012</p><p>He
is
Chairman
&
CEO
of
Telefónica
S.A
since
April
2016
and
he
joined
the
b
oard
of
directors
in
July
2006.
In
February
2022
he
assumed
the
Presidency
of
Fundación
Telefónica.
Also,
since
March
2019
he
is
member
of
the
Advisory
Council
of
SEAT,
S.A.,
since
February
2022,
Chairman
of
the
Board
of
the
GSMA
and
member
of
Board
of
Tru
stees
of
”la
Caixa”
Banking
Foundation
and,
since
May
2022,
Chair
of
ERT’s
Committee
Jobs,
Skills
&
Impact</p>
<p>He
began
his
professional
career
with
Auditors
Arthur
Young
in
1987,
before
joining
Benito
&
Monjardín/Kidder,
Peabody
&
Co.
in
1988.
He
joined
CEM
EX
in
1995
and,
in
1998,
he
was
promoted
to
Chief
Administration
and
Finance
Officer
of
the
CEMEX
Group
Indonesia.
He
has
a
degree
in
Economics
from
the
Complutense
University
of
Madrid
and
he
also
studied
Economics
at
the
Free
University
of
Brussels,
in
B
elgium.
He
holds
an
International
Management
Programme
from
IPADE.</p>
<p>Among
many
other
distinctions,
in
2016
he
was
named
“Best
CEO”
in
Spain
by
Forbes
Magazine
and
the
Consejo
Superior
de
Deportes
granted
him
the
entry
in
the
“Royal
Order
of
Merit
Sports”
i
n
the
category
of
Bronze
Medal.
In
2019
he
was
granted
with
the
“Cross
of
Military
Merit
with
white
distinction”,
he
received
the
“Manager
of
the
Year”
award
in
the
Large
Corporations
category
granted
by
the
Asociación
Española
de
Directivos
and
was
chosen
“Business
Leader
of
the
Year”
by
the
Spain
-
US
Chamber
of
Commerce.
In
2020
he
was
awarded
with
the
ECOFIN
prize
for
“Financiero
del
Año”
and
the
Spanish
Marketing
Association
has
named
him
“Lider
Empresarial
Impulso
del
Marketing”.
In
2021,
he
was
named
“
Honorary
Ambassador
of
Spain
Brand”
by
the
Leading
Brands
of
Spain
Forum
and
Actualidad
Económica
has
recognized
him
as
"Best
Businessman
of
the
Year".
In
November
2023,
he
received
an
honorary
degree
from
CEU
San
Pablo
University
and
was
named
“Business
P
erson
of
the
Year
2022”
by
the
UPF
Barcelona
School
of
Management.
Since
January
2024,
he
is
a
Trustee
of
Fundación
Amigos
de
la
Alhambra.
In
June
2024
he
has
received
the
"Gold
Medal"
recognition
from
the
Americas
Society.</p>
`,
},
    {
        name: `CARME ARTIGAS`,
        index: 3,
        description: `<p>Ca
rme
Artigas
is
a
Spaniard
executive
and
entrepreneur
in
the
fields
of
Big
Data,
Artificial
Intelligence,
Cybersecurity
and
Technology
Innovation,
with
over
30
years
of
experience.
She
is
a
renown
and
recognized
international
leader
in
Artificial
Intelligen
ce
regulation
and
governance.</p>
<p>
She
has
hold
several
roles
as
CEO,
Board
Advisor
and
Chairman
of
the
Board
in
several
public
and
private
companies.
She
co
-
founded
and
served
as
CEO
of
Synergic
Partners,
a
pioneering
European
Big
Data
company
acquired
by
Telefonica
Group
in
November
2015,
where
she
continued
as
CEO
until
the
company's
full
integration
into
Telefonica
Group.
In
January
2020</p>
<p>

5
she
was
appointed
the
1st
Secretary
of
State
for
Digitalization
and
Artificial
Intelligence
for
the
Government
of
Spai
n
until
December
2023,
culminating
her
role
with
the
approval
of
the
EU
AI
Act
during
the
Spanish
Presidency
of
the
EU.</p>
<p>he
is
currently
the
Co
-
Chair
of
the
United
Nations
AI
Advisory
Body
and
has
recently
been
appointed
Senior
Fellow
for
the
Belfer
Cente
r
in
the
Harvard
Kennedy
School.</p>
<p>Early
days
of
her
professional
career
include
executive
positions
at
Procter&Gamble,
Director
of
Business
Incubators
at
the
City
of
Barcelona
and
CEO
of
the
Ericsson
Innova,
the
European
Venture
Capital
firm
of
Ericsson
Gr
oup</p>
<p>She
is
a
MSc
in
Chemical
Engineering
by
Instituto
Qu
í
mico
de
Sarri
á
,
Master
Thesis
at
Max
Planck
Institute,
Post
-
graduate
in
Industry
Management
by
IQS,
Executive
Education
on
Venture
Capital
by
Haas
School
of
Economics
Berkeley
University.</p>
`
    },
    {
        name: `MAREK
BELKA`,
        index: 4,
        description: `<p>Prime
Minister
of
the
Republic
of
Poland
2004
-
2005
Professor
of
Economics
(College
of
Europe
Natolin
/
LSE
Institute
of
Global
Affairs)</p><p>
Born
in
January
1952
in
Łódź,
Poland.
Marek
Belka
graduated
from
the
University
of
Łódź
in
1972
and
continued
his
academic
career
at
the
Institute
of
Economics
at
his
alma
mater.
He
received
his
Ph.
D.
in
1978
and
a
postdoctoral
degree
(“habilitation”)
in
1986.
Marek
Belka
was
a
research
fellow
at
the
Columbia
and
Chicago
Universities
(1978
-
79,
1985
-
86)
and
the
London
School
of
Economics
(1990).
He
received
the
title
of
Professor
of
Economics
in
1994.</p>
<p>
Professor
Belka
served
twice
as
Deputy
Prime
Minister,
Minister
of
Finance
of
Poland
in
1997
and
2001
-
2002.

From
May
2004
to
October
2005,
Pro
fessor
Belka
served
as
Prime
Minister
of
Poland.</p>
<p>
He
has
also
held
numerous
high
-
ranking
positions
within
the
international
community.
In
2003,
he
served
as
Chairman
of
the
Council
for
International
Coordination
for
Iraq
and
as
Director
of
Economic
Policy
in
the
Coalition
Provisional
Authority
(2003
-
2004).
From
2006
to
2008,
he
held
office
in
the
United
Nations
as
Executive
Secretary
of
Economic
Commission
for
Europe
(UNECE)
in
Geneva.
Between
2008
and
2010,
he
worked
as
Director
of
the
European
Department
at
the
International
Monetary
Fund.
He
has
also
chaired
the
World
Bank/IMF
Development
Committee
(November
2011
–
October
2015)
and
served
as
a
Member
of
the
G20
Eminent
Persons
Group
on
Global
Financial
Governance
(2017).</p>
<p>
Between
2010
-
2016
Professor
Belka
served
as
the
Governor
of
the
National
Bank
of
Poland.
</p>
<p>
He
has
served
as
Member
of
the
European
Parliament
(2019
-
2024
term)
working
as
member
of
the
Economic
and
Monetary
Affairs
(ECON)
Committee
and
the
Subcommittee
on
Tax
Matters,
a
substitute
member
of
the
International
Trade
Committee
and
a
member
of
the
Delegation
for
relations
with
the
United
States.</p>
<p>Professor
Belka
is
married,
has
two
children
and
three
grandchildren</p>`
    },
    {
        name: `JASON
BLACKSTOCK`,
        index: 5,
        description: `<p>
            Dr
Jason
Blackstock
is
the
founder
&
CEO
of
the
How
to
Change
the
World
social
enterprise,
which
is
an
educational
spinout
from
University
College
London
(UCL)
providing
unique
sustainability
-
focused
experiential
learning
for
thousands
of
students
and
professionals
around
the
world.
Prior
to
spinning
How
to
Ch
ange
the
World
out,
he
served
as
the
Founding
Head
of
UCL’s
Department
of
Science,
Technology,
Engineering
and
Public
Policy.
        </p>
        <p>
        ason’s
professional
background
spans
quantum
physics
research
and
Silicon
Valley
tech
development;
global
climate
and
sustainabi
lity
science
&
policy;
sustainable
technology
innovation,
investment
&
policy;
higher
education
innovation
&
leadership;
and
social
entrepreneurship.
He
has
taught,
led
research
and
provided
policy
advice
from
universities
and
think
tanks
including
Harvard
,
Oxford,
UCL,
the
Centre
for
International
Governance
Innovation
and
the
International
Institute
for
Applied
Systems
Analysis;
authored
over
a
dozen 7
patents
and
more
than
100
academic
and
policy
publications;
and
co
-
chaired
and
authored
over
half
a
dozen
global
technology
assessments
with
leading
organisations
such
as
the
IPCC.</p>
<p>
ason
is
also
a
co
-
founder
&
Director
of
the
We
Make
Change
social
enterprise;
serves
or
has
served
as
an
advisory
board
member
for
a
wide
range
of
organisations
such
as
MIT’s
Inst
itute
of
Data,
Systems
and
Society,
the
Carbon
XPRIZE,
and
the
Institute
for
Science,
Society
and
Policy
at
the
University
of
Ottawa;
and
acts
as
an
advisor
to
a
range
of
impact
-
oriented
climate
startups
via
organisations
such
as
the
Creative
Destruction
L
ab.</p>
<p>
ason
holds
degrees
in
English
literature
from
Queen’s
University
(BA);
in
physics
from
the
University
of
Edinburgh
(MPhys)
and
the
University
of
Alberta
(PhD);
and
in
Public
Administration
from
Harvard
University
(MPA);
along
with
a
graduate
certific
ate
in
international
security
from
Stanford
University.
He
is
a
Fellow
of
RSA
and
the
World
Academy
of
Art
&
Science;
an
Adjunct
Professor
at
the
University
of
Waterloo;
and
a
Fellow
of
the
Centre
for
the
Governance
of
Change
at
IE
University.</p>
`
    },
    {
        name: `PHAEDRA
BOINODIRIS`,
        index: 6,
        description: `<p>
        A
fellow
with
the
London
-
based
Royal
Society
of
Arts,
Boinodiris
has
focused
on
inclusion
in
technology
since
1999.</p>
<p>
She
currently
leads
IBM
Consulting
’
s
Responsible
AI
Practice.</p>
<p>
She
is
the
co
-
author
of
the
book
‘
AI
for
the
Rest
of
Us
’
.
Boinodiris
is
a
co
-
founder
of
the
Future
World
Alliance,
a
501c3
dedicated
to
curating
K
-
12
education
in
AI
ethics.
In
2019,
she
won
the
United
Nations
Woman
of
Influence
in
STEM
and
Inclusivity
Award
and
was
recognized
by
Women
in
Games
Inter
national
as
one
of
the
Top
100
Women
in
the
Games
Industry
as
she
began
one
of
the
first
scholarship
programs
in
the
United
States
for
women
to
pursue
degrees
in
game
design
and
development.
</p>
`
    },{
        name: `JEFF
BULLWINKEL`,
        index: 7,
        description: `
        <p>
        Jeff
Bullwinkel
serves
as
Vice
President
&
Deputy
General
Counsel,
Corporate
External
&
Legal
Affairs,
Microsoft
EMEA.
He
is
based
in
London
and
oversees
the
company
’
s
legal
and
corporate
affairs
teams
across
Europe,
the
Middle
East,
and
Africa,
providing
suppo
rt
for
commercial
transactions
and
regulatory
counsel
on
public
policy
issues
relating
among
other
things
to
cybersecurity,
data
privacy,
artificial
intelligence,
digital
safety,
competition,
and
international
trade.
        </p>
        <p>
        Mr.
Bullwinkel
joined
Microsoft
in
200
0
and
previously
held
a
number
of
senior
roles
with
the
company
across
the
Asia
Pacific
region,
based
in
Hong
Kong,
Singapore
and
Sydney.
Prior
to
joining
Microsoft,
Mr.
Bullwinkel
was
with
Simpson
Thacher
&
Bartlett,
an
international
law
firm
based
in
New
York.
Mr.
Bullwinkel
also
served
as
a
federal
prosecutor
with
the
Office
of
International
Affairs,
Criminal
Division,
US
Department
of
Justice,
where
he
was
responsible
for
a
wide
range
of
matters
relating
to
international
law.
        </p>
        <p>
        Mr.
Bullwinkel
is
original
ly
from
the
New
York
area.
He
graduated
from
Duke
University
with
a
Bachelor
of
Arts
degree
and
received
his
law
degree
from
New
York
University.
He
is
a
member
of
the
New
York
State
Bar.
        </p>`
    },{
        name: `NADIA CALVIÑO`,
        index: 8,
        description: `<p>
        Nadia
Calviño
is
the
president
of
the
European
Investment
Bank.
She
was
appointed
on
1
January
2024.</p>
<p>President
Nadia
Calviño
is
a
Spanish
economist
and
lawyer
with
a
prominent
career
as
civil
servant
and
politician
in
the
Spanish
government
and
the
European
Commission.</p>
<p>Befor
e
becoming
President
of
the
European
Investment
Bank
Group
on
January
1st
2024,
Ms.
Calviño
served
from
June
2018
until
December
2023
as
Vice
-
President
of
Spain,
Minister
for
Economy,
Trade
and
Business
and
Minister
for
Economy
and
Digitalization.
She
chai
red
the
International
Monetary
and
Financial
Committee
of
the
IMF
in
2022
-
2023.</p>
<p>Before
joining
the
Spanish
government,
Ms.
Calviño
had
a
12
-
year
tenure
at
the
European
Commission
where
she
was
Deputy
Director
General
for
Competition,
Deputy
Director
General
for
Financial
Services,
and
Director
General
responsible
for
the
EU
Budget
since
2014.</p>
<p>
Her
earlier
career
in
Spain
encompassed
various
managerial
positions
as
a
civil
servant
at
the
Ministry
for
Economy,
focusing
on
areas
such
as
macroeconomic
ana
lysis
and forecasting,
foreign
trade
and
economic
policy,
before
becoming
Director
General
for
Competition
in
2004.
In
addition
to
her
career
in
public
service,
Ms.
Calviño
was
associated
professor
at
the
Faculty
of
Economics
of
the
Universidad
Complutense
of
Madrid
and
has
authored
numerous
articles.</p>
<p>
Her
expertise
and
leadership
have
been
recognised
with
several
prestigious
awards,
including
the
“
US
Foreign
Policy
Association
Medal,
”
the
“
Women
and
Technology
Award,
”
and
the
“
Master
of
Digital
”
award,
sho
wcasing
her
contributions
in
the
areas
of
technological
development
and
international
cooperation.
</p>
<p>
Ms.
Calviño
holds
a
degree
in
economics
from
the
Universidad
Complutense
de
Madrid
and
a
degree
in
law
from
the
Universidad
Nacional
de
Educación
a
Distanci
a.
</p>`
    },{
        name: `KAMISSA CAMARA`,
        index: 28,
        description: `<p>
        Ambassador
Kamissa
Camara
is
a
professor
of
practice
in
international
diplomacy
at
the
Gerald
R.
Ford
School
of
Public
Policy
’
s
Weiser
Diplomacy
Center.
She
is
also
a
Senior
Africa
Advisor
at
the
United
States
Institute
of
Peace
and
a
Non
-
Resident
Scholar
at
the
Middle
East
Institute</p>
<p>
Camara
has
held
high
-
ranking
positions
in
the
Malian
government,
including
Minister,
Chief
of
Staff
to
the
President,
Minister
of
Foreign
Affairs
and
International
Cooperation,
and
Minister
of
Digital
Economy
and
Planning.
With
an
impressive
background
in
African
politics,
she
has
also
served
as
Africa
Director
for
PartnersGlobal,
Senior
Program
Officer
at
the
National
Endowment
Democracy,
and
Program
Officer
at
the
International
Foundation
for
Electoral
Systems.</p>
<p>
As
a
leading
expert
on
international
affairs,
Camara
is
frequently
invited
to
share
her
insights
on
various
TV
and
radio
programs
such
as
CNN,
Aljazeera,
BBC
Africa,
Voice
of
America
(French
and
English),
France24,
and
TV5.</p>
<p>
Camara
holds
a
Master's
degree
in
International
Development
from
the
Universit
é
de
Grenoble
and
is
currently
completing
her
PhD
in
political
science
at
the
University
of
Oxford.</p>`
    },{
        name: `JOSÉ MANUEL CAMPA`,
        index: 9,
        description:  `<p>
        José
Manuel
Campa,
is
the
Chairperson
of
the
European
Banking
Authority
(EBA).
He
was
appointed
in
March
2019
and
is
serving
a
renewable
five
-
year
term.
He
represents
the
Authority
and
by
chairing
the
meetings
of
the
Board
of
Supervisors
and
of
the
Management
Board,
he
steers
the
strategic
dir
ection
of
the
Authority.</p>
<p>
From
2015
and
prior
to
this
appointment,
Campa
served
as
Global
Head
of
Regulatory
Affairs,
for
the
Grupo
Santander.
Prior
to
that,
he
was
Professor
of
Finance
and
Economics
at
IESE
Business
School.</p>
<p>
Between
2009
and
2011
Campa
s
erved
as
Secretary
of
State
for
the
Economy
in
the
Ministry
of
Economy
and
Finances
of
Spain.
He
was
a
member
of
the
Financial
Stability
Board,
the
board
of
the
European
Financial
Stability
Facility,
the
Economic
and
Financial
Committee
and
alternate
gove
rnor
in
multilateral
financial
institutions.
He
has
served
in
the
Expert
Group,
chair
by
Mr.
Erkki
Liikanen,
evaluating
policy
recommendations
on
structural
reforms
for
the
European
Banking
industry.</p>
<p>
He
has
also
taught
at
the
Stern
School
of
Business
of
N
ew
York
University
and
at
Columbia
University.
He
has
been
Research
Associate
at
the
National
Bureau
of
Economic
Research
and
Research
Fellow
at
the
Center
for
Economic
Policy
Research.
Mr.
Campa
has
also
been
a
consultant
to
a
large
number
of
internationa
l
organizations,
including
the
International
Monetary
Fund,
the
Inter
-
American
Development
Bank,
the
Bank
of
International
Settlements
in
Basel,
and
the
European
Commission.</p>
<p>
He
has
served
on
the
boards
of
Prime
Collateralised
Securities
(PCS)
Europe,
Brue
gel,
and
General
de
Alquiler
de
Maquinaria.</p>
<p>
José
Manuel
Campa
holds
a
Ph.D.
and
a
master’s
degree
in
economics
from
Harvard
University
and
a
Licenciatura
in
law
and
in
economics
from
the
Universidad
de
Oviedo.
</p>`,
    },{
        name: `EDOARDO
CAMPANELLA`,
        index: 10,
        description: `<p>Edoardo
Campanella
is
an
economist
and
author.
He
works
as
senior
global
economist
at
UniCredit
Bank
and
is
a
Research
Fellow
at
the
Harvard
Kennedy
School.</p>
<p>
He
recently
published
with
Marta
Dassu’
Anglo
Nostalgia:
The
Politics
of
Emotion
in
a
Fractured
W
est
(Oxford
University
Press).
He
writes
globally
syndicated
columns
for
Project
Syndicate,
and
his
writings
have
appeared,
among
the
others,
in
Foreign
Policy,
Foreign
Affairs,
Survival
and
many
other
media
outlets.
</p>
<p>
Edoardo
is
also
a
former
David
Rockef
eller
Fellow
of
the
Trilateral
Commission,
where
he
directed
the
Taskforce
on
Global
Capitalism
in
Transition,
culminating
with
the
publication
of
A
New
Spirit
of
Capitalism.
He
previously
worked
for
the
economic
research
departments
of
the
World
Trade
Org
anisation,
the
World
Economic
Forum
and
the
Italian
Senate.
In
2016,
he
was
a
shortlisted
author
for
the
Bracken
Bower
Prize,
awarded
by
the
Financial
Times
and
McKinsey
to
promising
writers
under
the
age
of
35.
He
holds
an
MPA
from
the
Harvard
Kennedy
Sch
ool
that
he
attended
on
a
Fulbright
scholarship.
While
at
Harvard,
he
was
awarded
the
Certificate
for
Teaching
Excellence
for
his
teaching
activity.
He
is
also
affiliated
with
the
Aspen
Institute,
the
Centre
for
the
Governance
of
Change
of
IE
University
in
Madrid
and
the
Council
for
Italy
and
the
United
States.</p>`,
    },{
        name: `
JAY
COLLINS`, index: 11,
        description: `<p>
        Jay
Collins
is
Vice
Chairman
of
Banking,
Citi
and
is
Citi
’
s
senior
banker
for
governments
globally.
He
has
covered
clients
around
the
world
in
every
significant
sector
and
run
transactions
across
Citi
’
s
full
product
spectrum,
including
privatizations,
liability
management,
infrastructure
finance,
structure
products,
digital
solutions,
and
M&A.</p>
<p>
Jay
was
Global
Head
of
Citi
’
s
Public
Sector
Group
from
200
5
-
2011.
During
2006
-
2007,
he
was
also
Citi
’
s
Global
Head
of
Infrastructure.
Prior
to
that,
Jay
has
been
Head
of
Central
and
Eastern
Europe,
Middle
East,
and
Africa
(CEEMEA)
for
Global
Banking
at
Citi
as
well
as
the
senior
foreigner
in
Nikko
Citigroup
’
s
Inv
estment
Banking
Division
in
Tokyo
</p>
<p>
Jay
has
a
Master
of
Science
in
Foreign
Service
from
Georgetown
University,
where
he
graduated
with
Honors
in
1989.
He
speaks
Japanese,
Portuguese,
and
Spanish.
</p>`
    },{
        name: `CARLOS CUERPO`,
        index: 12,
        description: `<p>
        Minister
of
Economy,
Trade
and
Business
of
the
Government
of
Spain</p>
<h5>FUNCTIONS</h5>
<p>
As
Minister
of
Economy,
Trade
and
Enterprise,
he
is
responsible
for
proposing
and
implementing
the
Government's
policy
on
economic
matters
and
reforms
to
improve
competitiveness
and
trade.</p>
<h5>
ACADEMIC
BACKGROUND</h5>
<p>
Degree
in
Economics
(2003)
from
the
Universi
ty
of
Extremadura,
Master's
Degree
in
Economics
from
the
London
School
of
Economics
(2004)
and
PhD
in
Economics
from
the
Autonomous
University
of
Madrid
(2017).</p>
<p>
Civil
servant
of
the
Cuerpo
Superior
de
T
é
cnicos
Comerciales
y
Economistas
del
Estado
since
2008.</p>
<h5>
PROFESSIONAL
EXPERIENCE</h5>
<ul>
<li>
Appointed
Minister
of
Economy,
Trade
and
Enterprise
by
Royal
Decree
1239/2023,
of
29
December
(BOE
no.
312.)</li>
<li>
Secretary
General
of
the
Treasury
and
International
Finance
fro
m
August
2021
to
December
2023.</li>
<li>
Director
General
of
Macroeconomic
Analysis
at
the
Ministry
of
Economic
Affairs
and
Digital
Transformation
from
February
2020
to
August
2021.</li>
<li>
Director
of
the
Economic
Analysis
Division
at
the
Independent
Authority
for
Fiscal
Responsibility
(AIReF)
from
November
2016
to
January
2020.</li>
<li>
Deputy
Director
General
of
Public
Debt
at
AIReF
from
May
2014
to
October
2016.
</li>
<li>
Economic
Analyst
at
the
Directora
te
-
General
for
Economic
and
Financial
Affairs
of
the
European
Commission
from
May
2011
to
April
2014</li>
<li>
Economic
Analyst
in
the
Directorate
General
for
Macroeconomic
Analysis
and
International
Economics
of
the
Ministry
of
Economy
and
Competitiveness
from
Ma
y
2008
to
April
2011.</li>
</ul>`
    },{
        name: `DAVIDE
DATTOLI`,
        index: 13,
        description: `<p>
        "The
best
way
to
predict
the
future
is
to
invent
it."
-
Davide
Dattoli,
Founder
&
Executive
Chairman
of
Talent
Garden,
who
is
reshaping
the
way
we
learn
and
connect
in
the
digital
ecosystem.
        </p>
        <p>
        Davide
Dattoli
is
the
Founder
and
Executive
Chairman
of
Talent
Garden,
the
largest
EduTech
company
based
in
Europe,
dedicated
to
helping
individuals
and
organizations
become
"future
-
proof"
by
enhancing
their
digital
skills.
Established
in
Italy
in
2011,
Talent
Garden
has
since
expanded
to
12
markets
across
Europe,
Brazil,
and
Singapore.
The
company
operates
under
three
brands:
Talent
Garden,
Hyper
Island,
and
Italian
Tech
Academy.
Our
uniqueness
lies
in
a
robust
digital
and
tech
community
that
inhabits
our
physical
campuses
across
Europe,
creating
learning
opportunities
for
bo
th
students
and
companies.
Currently,
Talent
Garden
trains
25,000
professionals
and
students
annually,
hosts
4,500
top
tech
startups
and
professionals,
and
welcomes
over
500,000
visitors
to
our
campuses
each
year
in
a
lifelong
learning
environment.</p>
<p>
He
is
also
a
Venture
Founder
and
board
member
of
Italian
Founders
Fund,
Italy's
first
venture
capital
fund
established
by
founders,
for
founders.
We
have
united
over
100
experienced
entrepreneurs
to
build
the
premier
founder
-
backed
VC
community,
actively
support
ing
Italy’s
next
generation
of
exceptional
talent
and
digital
innovation.
IFF
leads
or
follows
in
pre
-
seed
and
seed
rounds.</p>
<p>
Davide
is
a
sought
-
after
speaker
and
serves
on
the
boards
of
numerous
companies
at
the
European
level.
He
has
been
recognized
in
Fo
rbes'
30
Under
30
technology
list
in
Europe
and
received
a
WIRED
nomination
as
one
of
the
top
5
innovators
in
Italy.
Additionally,
he
is
a
board
member
of
many
private
and
public
organizations.
He
is
actively
involved
as
a
board
member
of
the
Telethon
Foun
dation,
the
most
significant
Italian
non
-
profit
organization
supporting
rare
diseases.
Davide
also
personally
invests
in
several
startups
in
the
Lifestyle
and
Education
sectors
across
Europe,
including
Will
Media,
WeRoad,
and
Bending
Spoons.</p>
<p>
Before
foundi
ng
Talent
Garden
and
serving
as
its
CEO
for
the
first
ten
years,
he
worked
on
digital
strategies
at
Condé
Nast
and
consulted
for
a
dozen
international
companies
on
digitalization.
Alongside
running
businesses,
he
has
completed
executive
courses
at
Stanford
University
and
Harvard
Business
School.</p>
        `
    },{
        name: `JOSÉ MARÍA DE AREILZA`,
        index: 14,
        description: `<p>José
M.
de
Areilza
Carvajal
is
the
Secretary
General
of
Aspen
Institute
Spain,
an
educational
and
policy
studies
organization
,
partner
of
The
Aspen
Institute
(USA).
He
is
also
a
Professor
and
Jean
Monnet
Chair
at
ESADE
Business
School,
Ramón
Llull
University,
and
the
Editor
-
in
-
Chief
of
Política
Exterior,
the
leading
magazine
on
foreign
affairs
in
Spanish.
He
has
been
Visiting
Professor
at
INSEAD
Business
School
(Fontainebleau),
William
and
Mary
School
of
Law,
Virginia
and
London
Business
School.</p>
<p>
He
holds
a
Doctorate
degree
(S.J.D.)
from
Harvard
Law
School
and
has
published
extensively
on
EU
Law
and
Politics,
as
well
as
Spanish
Foreign
Policy.
Between
1996
-
2000
he
served
as
Advisor
on
European
Affairs
in
the
Spanish
Prime
Minister’s
Office.
He
writes
a
weekly
column
in
ABC,
a
national
newspaper.</p>
<p>
He
is
also
Vice
President
of
the
US
-
Spain
Council
Foundation,
Academy
Adjunct
Faculty
at
Chatham
House,
London,
Member
of
the
Euro
pean
Council
on
Foreign
Relations
and
Trustee
of
the
Spanish
Navy
Museum,
Ministry
of
Defence.
He
is
a
Member
of
the
New
York
Bar
and
Editor
of
the
wine
blog
Iberians
on
wine</p>`
    },{
        name: `LUIS DE CARLOS`,
        index: 15,
        description: `<p>Luis
de
Carlos
Bertrán
(Madrid,
1960)
was
senior
partner
and
managing
partner
of
the
leading
Spanish
law
firm
Uría
Menéndez
for
17
years
before
retiring
from
the
firm
on
1
January
2023.
Luis
joined
Uría
Menéndez
in
1982
and
became
partner
in
1991,
managing
partner
in
2005
and
senior
part
ner
in
2017.
He
is
currently
senior
advisor
to
Morgan
Stanley
in
Spain
and
chairman
of
IE
LawAhead,
the
legal
profession
centre
at
the
prestigious
private
university
Instituto
de
Empresa</p>
<p>
Luis
is
very
passionate
about
non
-
profit
work
and
holds
the
followi
ng
positions:
    <ul>
        <li>
            Chairman
of
Fundación
ProCNIC
(Spanish
National
Centre
for
Cardiovascular
Research)
        </li>
        <li>
        Vice
chairman
of
the
Friends
of
the
Prado
Museum
Foundation
        </li>
        <li>
        Board
member
of
the
Professor
Uría
Foundation</li>
    </ul>
</p>
<p>
He
has
received
numerous
recognitions
and
awards:
<ul>
    <li>
    M
edal
of
Honour
of
the
World
Law
Foundation
(2023)
    </li>
    <li>
    Aptissimi
Award
by
Esade
Alumni
(2022)
    </li>
    <li>
    Gran
Cruz
de
la
Orden
del
Mérito
Civil,
awarded
by
the
Spanish
Government
(2022)</li>
<li>
Cruz
de
la
Orden
de
San
Raimundo
de
Peñafort,
awarded
by
the
Spanish
Ministry
of
Justi
ce
(2017</li>
<li>
    Best
Managing
Partner
of
the
Year
Award
at
the
Forbes
Lawyers
Awards
(2018)
</li>
<li>
Best
Lawyer
Award
at
the
Expansion
Legal
Awards
(2018)</li>
<li>
Best
Reputation
Award
at
the
Legal
Marcom
Awards
(2018)
</li>
<li>
Professional
Career
Award
at
the
Confilegal
Awards
(2018)
</li>
<li>
Lawyer
of
the
year
in
Spain
(capital
markets),
Best
Lawyers
(2018
and
2019)
</li>
<li>
European
Managing
Partner
of
the
Year
at
The
Lawyer
European
Awards
(2016)
</li>
<li>
Consolidated
Career
Award
at
the
Icade
Association
Awards
(2011)
</li>
</ul>
<h5>
EDUCATION</h5>
<ul>
<li>
Law
Degree
with
Honours,
Univ
ersidad
Pontificia
Comillas
(1982)
</li>
<li>
Business
Administration
Degree,
Universidad
Pontificia
Comillas
(1983)
</li>
<li>Doctor
in
Law,
cum
laude,
Universidad
Pontificia
Comillas
(1997)</li>
</ul>
<h5>
PUBLICATIONS
</h5>
<li>
Luis
has
authored
numerous
books
and
articles
on
legal
matters
and
othe
r
topics</li>
</p>`
    },{
        name: `LUIS
DE
GUINDOS`,
        index: 16,
        description: `<p>
        Vice
-
President
of
the
European
Central
Bank
        </p>
        <h5>
        EDUCATION</h5>
        <ul>
            <li>
                1977
-
1982.
BSc
in
Economics
from
CUNEF,
Colegio
Universitario
de
Estudios
Financieros
(Spain)
–
Graduated
with
honours
            </li>
            <li>
                1984.
Té
cnico
Comercial
y
Economista
del
Estado
(State
Economist
and
Trade
Expert,
grade
“A”
public
examination,
first
in
order
of
merit)
            </li>
        </ul>
        <h5>PROFESSIONAL
CAREER</h5>
<ul>
    <li>
    2018.
Vice
-
President
of
the
European
Central
Bank</li>
<li>
2016
-
2018.
Minister
of
Economy,
Industry
and
Competiti
veness
</li>
<li>
2011
-
2016.
Minister
of
Economy
and
Competitiveness
</li>
<li>
2010
-
2011.
Director,
IE
Business
School
and
PwC
Center
for
the
Finance
Sector
</li>
<li>
2008
-
2009.
Head
of
Financial
Services,
PricewaterhouseCoopers
</li>
<li>
2006
-
2008.
Chief
Executive
Officer
Iberia,
Lehman
Brothers,
and
Chief
Executive
Officer,
Nomura
Securities
</li>
<li>
2002
-
2004.
Secretary
of
State
for
Economic
Affairs
and
member
of
the
Economic
and
Financial
Committee
of
the
EU
</li>
<li>
2000
-
2002.
Secretary
General
for
Economic
and
Competition
Policy
</li>
<li>
1996
-
2000.
Director
Ge
neral
for
Economic
and
Competition
Policy</li>
<li>1996
-
2000.
Vice
Chairman,
Economic
Policy
Committee
of
the
EU</li>
<li>
1988
-
1996.
Chief
Executive
Officer,
AB
Asesores
</li>
</ul>
`
    },{
        name: `ALEXANDRA
DE
HOOP
SCHEFFER`,
        index: 17,
        description: `<p>Dr.
Alexandra
de
Hoop
Scheffer
is
Senior
Vice
President
and
member
of
the
executive
committee
of
the
German
Marshall
Fund
of
the
United
States
(GMF),
a
leading
global
think
tank.
In
her
role,
she
oversees
GMF
’
s
Geostrategy
policy
and
risk
advisory
initiatives
across
Europe,
the
United
States
and
the
I
ndo
-
Pacific
region.
She
is
a
renowned
expert
in
European
affairs,
transatlantic
and
international
relations.</p><p>
With
over
15
years
of
experience
in
senior
advisory
and
executive
roles,
Dr.
de
Hoop
Scheffer
advises
governments,
corporations,
and
financial
ins
titutions
on
the
political,
geopolitical,
and
macroeconomic
trends
that
shape
their
operations
and
strategies,
and
helps
them
develop
both
early
-
warning
systems
and
forward
-
looking
decision
-
making
processes.
</p>
<p>
As
co
-
founder
and
president
of
her
own
consulti
ng
firm,
Dr.
de
Hoop
Scheffer
crafts
corporate
diplomacy
strategies
for
global
business
leaders
and
boards.
She
also
serves
as
an
independent
non
-
executive
board
director
for
several
organizations,
including
the
Supervisory
Board
of
Meridiam,
the
French
Tr
easury
Strategic
Committee
and
as
chair
of
the
Advisory
Board
of
the
French
Chief
of
Defense
Staff.
She
is
also
a
member
of
the
board
of
the
France
-
Nederland
Cultuurfonds,
the
Advisory
board
of
the
Fondation
pour
la
Recherche
Strat
é
gique
(FRS)
and
the
Edit
orial
board
of
The
Washington
Quartely
journal.
She
is
a
member
of
the
French
Section
of
the
Trilateral
Commission.
</p>
<p>
Before
joining
GMF,
Dr.
de
Hoop
Scheffer
held
key
strategic
advisory
positions
in
the
French
government,
academia,
and
international
organi
zations,
including
with
the
Policy
Planning
Staff
of
the
French
Ministry
of
Foreign
Affairs
(2009
-
2011),
NATO
’
s
Supreme
Allied
Commander
Europe
(2010
-
2013),
the
French
Ministry
of
Defense
(2006
-
2009),
and
the
United
Nations
Peacekeeping
Operations
(2006).
She
also
served
as
an
associate
professor
at
Sciences
Po
Paris
and
a
research
fellow
at
the
Institut
Fran
ç
ais
des
Relations
Internationales
(IFRI).</p>
<p>
A
dual
French
-
Dutch
citizen,
Dr.
de
Hoop
Scheffer
holds
a
PhD
in
Political
Science
from
Sciences
Po
Paris
a
nd
is
the
author
of
Hamlet
en
Irak
(CNRS
É
ditions,
2007).
She
is
a
frequent
public
speaker
and
writer.</p>`,
    },
    {
        name: `KARIM
ELAYNAOUI`,
        index: 18,
        description: `Karim
El
Aynaoui
is
Executive
President
of
the
Policy
Center
for
the
New
South.
He
is
also
Executive
Vice
-
President
of
Mohammed
VI
Polytechnic
University
and
Dean
of
its
Humanities,
Economics
and
Social
Sciences
Cluster.<p>
Karim
El
Aynaoui
is
an
economist.
From
2005
to
2012,
he
worked
at
the
Central
Bank
of
Morocco
where
he
held
the
position
of
Director
of
Economics,
Statistics,
and
International
Relations.
At
the
Central
Bank
of
Morocco,
he
was
in
charge
of
the
Research
Department
and
equally
a
member
of
t
he
Governor
’
s
Cabinet.
Previously,
he
worked
for
eight
years
at
the
World
Bank
as
an
Economist
for
its
regional
units
of
the
Middle
East
and
North
Africa
and
Africa.
Karim
El
Aynaoui
has
published
books
and
journal
articles
on
macroeconomic
issues
in
devel
oping
countries.
His
recent
research
has
been
focused
on
growth
and
the
labor
market
in
Morocco,
as
well
as
on
reforming
international
development
economy.</p><p>
Karim
El
Aynaoui
holds
scientific
and
advisory
positions
at
various
institutions.
He
is
currently
a
member
of
the
Malabo
Montpellier
Panel,
the
Scientific
Committee
of
The
Italian
Institute
for
International
Political
Studies,
the
Scientific
Council
of
the
Moroccan
Capital
Market
Authority,
the
International
Board
of
Leonardo
Med
-
Or
Foundation,
the
Adv
isory
Council
of
the
School
of
Global
Affairs
and
Public
Policy
of
the
American
University
of
Cairo,
Morocco
’
s
Chapter
of
the
Confr
é
rie
des
Compagnons
de
Gutenberg,
and
a
global
member
of
the
Trilateral
Commission.
He
serves
as
advisor
to
the
CEO
and
Chair
man
of
OCP
Group
and
is
a
board
member
of
OCP
Foundation.</p>
<p>
Karim
El
Aynaoui
holds
a
PhD
in
Economics
from
the
University
of
Bordeaux
in
France
where
he
taught
courses
in
Statistics
and
Economics
for
three
years.</p>
<p>He
is
Commendatore
of
the
Order
of
Merit
o
f
the
Italian
Republic.</p>`,
    },{
        name: `JOSÉ ANTONIO GARCÍA BELAUNDE`,
        index: 20,
        description: `<p>He
is
currently
President
of
the
EU
-
LAC
Foundation.
A
foundation
created
by
the
Heads
of
State
and
Government
of
the
European
Union
(EU)
and
the
Community
of
Latin
American
and
Caribbean
States
(CELAC)
in
2010.
Its
members
are
the
EU
and
CELAC
countries
an
d
the
EU
itself.</p>
<ul>
        <li>
        He
was
the
Representative
in
Europe
of
CAF,
Development
Bank
of
Latin
America
from
2018
-
2022.</li>
<li>
Ambassador
of
Peru
to
Spain
from
2016
to
2018,
Co
-
Agent
of
Peru
to
the
International
Court
of
Justice
in
The
Hague
from
2011
to
2014
and
Mini
ster
of
Foreign
Affairs
of
Peru
from
2006
to
2011.
</li>
<li>
Between
1990
and
2006,
he
served
as
Director
-
Secretary
of
the
Cartagena
Agreement,
which
later
became
the
Andean
Community,
where
he
was
Managing
Director.
</li>
<li>
He
has
had
an
extensive
career
in
Peru's
diplomatic
missions
to
the
United
Nations
in
New
York,
France,
Mexico,
Spain,
Ecuador
and
the
United
States
of
America.
He
has
been
Ambassador
to
the
Latin
American
Integration
Association
(ALADI)
in
Montevideo.
</li>
<li>
H
e
has
taught
at
the
Diplomatic
Academy
of
Peru
and
at
the
Institute
of
Government
of
the
San
Martin
de
Porres
University
in
Lima.
</li>
</ul>
<p>
He
studied
at
the
Pontificia
Universidad
Cat
ó
lica
del
Per
ú
and
at
the
Diplomatic
Academy,
where
he
graduated
with
a
degree
i
n
International
Relations.
His
post
-
graduate
studies
were
at
Oxford
University
and
he
obtained
a
Master's
degree
in
International
Relations
and
International
Law
from
the
Instituto
Ortega
y
Gasset
in
Madrid.</p>`,
    },{
        name: `TONY GARDNER`,
        index: 21,
        description: `<p>
        Tony
Gardner
is
a
Senior
Adviser
at
the
Brunswick
Group,
a
leading
firm
providing
advice
to
clients
on
communications
and
critical
issues.
        </p>
        <p>Tony
is
also
Executive
Adviser
at
Brookfield
and
Second
Vice
President
and
member
of
the
Executive
Committee
of
the
Board
of
Iberdrola.</p>
<p>
He
served
as
US
Ambassador
to
the
European
Union
(2014
-
2017).
In
that
capacity,
he
played
a
key
role
in
the
negotiations
of
a
Transatlantic
Trade
and
Investment
Partnership
Agreement
and
of
Privacy
Shield,
the
legal
framework
enabling
flows
of
personal
data
from
Europe
to
the
United
States.
</p>
<p>
Before
serving
in
Brussels,
Tony
worked
as
a
Managing
Director
at
Palamon
Capital
Partners,
a
private
equity
firm
and
GE
Capital,
both
in
London.
During
1994
-
1995
he
served
as
Director
of
European
Affair
s
at
the
National
Security
Council.
</p>
<p>
He
is
the
author
of
“
Stars
with
Stripes:
The
Essential
Partnership
between
the
European
Union
and
the
United
States,
”
Palgrave
MacMillan
(2020),
voted
by
Foreign
Affairs
as
one
of
the
best
foreign
policy
books
of
2020,
and
“
A
New
Era
in
US
-
EU
Relations?
”
Avebury
Press
(1997).
Tony
appears
regularly
on
CNN,
CNBC,
MSNBC,
Bloomberg,
BBC,
Euronews
and
Fox
Business
News
as
a
commentator
on
transatlantic
issues.
He
has
appeared
in
The
Wall
Street
Journal,
the
New
York
Times,
the
Financial
Times
and
Foreign
Affairs.</p>
<p>
Tony
Gardner
has
lived
in
Europe
for
30
years
and
is
a
dual
US
and
Italian
national.
He
is
married
to
a
Spaniard.
</p>`
    },{
        name: `JARED
GENSER`,
        index: 22,
        description: `<p>
        Jared
Genser
is
an
international
human
rights
lawyer.
He
is
Managing
Director
of
Perseus
Strategies,
an
international
law
firm,
Special
Advisor
on
the
Responsibility
to
Protect
to
the Organization
of
American
States,
Senior
Fellow
for
Technology
and
Human
Rights
at
Harvard
University’s
Carr
Center
for
Human
Rights
Policy,
Lecturer
in
Law
at
Stanford
Law
School,
and
outside
General
Counsel
to
the
Neurorights
Foundation.
Referred
to
by
the
New
York
Times
as
“The
Extractor”
for
his
work
freeing
political
prisoners
worldwide,
he
has
represented
as
pro
bono
counsel
five
Nobel
Peace
Prize
Laureates,
including
three
Laureates
who
won
their
Prize
while
imprisoned
—
Aung
San
Suu
Kyi
(Burma,
2006
-
2010),
Liu
Xiaobo
(China,
2010
-
2017),
and
Ales
Bialiatski
(Belarus,
2023
-
Present)
—
as
well
as
Archbishop
Desmond
Tutu
and
Elie
Wies
el.
He
was
previously
a
partner
in
the
government
affairs
practice
of
DLA
Piper
LLP
and
a
management
consultant
with
McKinsey
&
Company.
Over
his
career,
he
has
also
advised
multilateral
institutions,
governments,
companies,
foundations,
and
non
-
government
al
organizations
on
ensuring
their
work
was
consistent
with
international
human
rights,
labor
rights,
and
environmental
rights
standards.
        </p>
        <p>
        He
holds
a
B.S.
from
Cornell
University,
an
M.P.P.
from
Harvard
University’s
John
F.
Kennedy
School
of
Government,
w
here
he
was
an
Alumni
Public
Service
Fellow,
and
a
J.D.
cum
laude
from
the
University
of
Michigan
Law
School.
He
has
also
previously
taught
as
an
Adjunct
Professor
of
Law
at
Georgetown
University
Law
Center
and
the
University
of
Pennsylania
Law
School.
        </p>
        <p>
            Genser’s
forthcoming
book
is
a
co
-
edited
volume
with
former
UN
High
Commissioner
for
Human
Rights
Zeid
Ra’ad
Al
Hussein
entitled
The
Oxford
Handbook
on
the
UN
Human
Rights
System
(Oxford
University
Press,
2025).
He
is
also
author
of
The
UN
Working
Group
on
A
rbitrary
Detention:
Commentary
and
Guide
to
Practice
(Cambridge
University
Press,
2019)
and
co
-
editor
of
The
UN
Security
Council
in
the
Age
of
Human
Rights
(Cambridge
University
Press,
2016)
and
The
Responsibility
to
Protect:
The
Promise
of
Stopping
Mass
A
trocities
in
Our
Times
(Oxford
University
Press,
2011).
        </p>
        <p>
        He
has
received
the
Tällberg
Eliasson
Global
Leadership
Prize,
American
Bar
Association’s
International
Human
Rights
Award,
Liberty
in
North
Korea’s
Freedom
Fighter
Award,
and
the
Charles
Bronfman
P
rize.
He
is
a
life
member
of
the
Council
on
Foreign
Relations,
Fellow
of
the
Royal
Society
of
the
Arts,
and
Young
Global
Leader
of
the
World
Economic
Forum
(2008).
        </p>`
    },{
        name: `SYLVIE GOULARD`,
        index: 23,
        description: `<p>Sylvie
Goulard
is
President
of
the
Deutsch
Französisches
Institut
(Ludwigburg,
Germany)
and
Vice
President
of
the
Institute
for
European
Policymaking
at
Bocconi
University
(Milano,
Italy).
She
is
also
Professor
of
Practice
at
SDA
Bocconi.</p>
<p>In
June
2023,
she
was
designated
co
-
chair
(with
Dame
Amelia
Fawcett)
of
a
Franco
British
initiative
aiming
at
creating
nature
related
financial
instruments
to
tackle
climate
change
and
biodiversity
loss.</p>
<p>
From
January
2018
to
December
2022,
she
was
deputy
governor
of
the
Banque
de
France
/
Eurosystem
with
a
portfolio
comprising
international
issues,
research,
public
financial
education
and
financial
stability
issues,
including
those
related
to
climate
and
the
monitoring
of
the
secretariat
of
the
Network
for
Greening
the
Financial
System
(NGFS)
that
coordinates
the
work
of
around
120
Central
Banks
and
supervisors
committed
to
tackle
climate
related
financial
risks
and
encourage
sustainable
development.
Within
the
NGFS,
Mrs
Goulard
co
-
chaired
the
Task
Force
on
nature
-
related
risks.</p>
<p>
After
the
presidential
election
in
2017,
Mrs
Goul
ard
was
Minister
of
Defense
in
the
first
Edouard
Philippe
Government.
</p>
<p>
From
2009
to
2017,
she
served
as
a
member
of
the
European
Parliament
(ALDE
group
/
Econ
committee).
</p>
<p>
She
was
before
a
political
advisor
to
Romano
Prodi
during
his
time
as
President
of
t
he
European
Commission
and
Chair
of
the
French
European
Movement.
</p>
<p>
In
2009
she
received
an
award
(Prix
du
livre
Européen)
for
her
book
L’Europe
pour
les
Nuls.</p>`,
    },{
        name:`FRANÇOIS GOUYETTE`,
        index: 24,
        description: `<p>
Franç
ois
Gouyette
has
served
as
Ambassador
of
France
from
2001
to
2023
in
five
arab
countries:
UAE,
Libya,
Tunisia,
Saudi
Arabia
and
Algeria.
He
was
previously
DCM
in
Syria
and
Turkey.
He
has
also
been
Diplomatic
Advisor
to
the
Minister
of
Interior
and
Ambassador
in
charge
of
the
EUROMed
process
in
the
Frenc
h
Ministry
of
Foreign
Affairs.
He
is
graduated
in
Law
from
the
Paris
University
and
in
Arabic
from
the
Oriental
School
in
Paris.
        </p>`
    },{
        name:`NINA HÄLG`,
        index: 25,
        description: `<p>
        Nina
Hälg
is
a
Manager
at
Deloitte
Consulting
based
in
Zurich,
Switzerland.
Her
focus
lies
in
providing
consulting
services
on
digital
transformation
and
organizational
change
programs
to
government
entities,
the
United
Nations
and
international
development
organizations.
Before
joining
the
private
sector,
she
spent
9+
years
in
th
e
public
sector
focusing
on
humanitarian,
human
rights
issues,
and
the
UN’s
sustainable
development
agenda</p>
<p>
From
2019
-
2022,
Nina
served
as
Programme
Manager
for
Multilateral
Affairs
at
the
Federal
Department
of
Foreign
Affairs
(FDFA)
in
Switzerland
where
she
was
responsible
for
Switzerland’s
foreign
policy
on
migration
with
a
focus
on
human
rights,
peace
and humanitarian
issues,
managing
a
global
project
portfolio
with
NGOs,
academia
and
private
sector
actors.
</p>
<p>
From
2014
-
2018,
she
held
several
positions
at
the
United
Nations
Headquarters
in
New
York
including
at
the
Office
of
High
Commissioner
for
Human
Rights
(OHCHR),
the
Department
for
Economic
and
Social
Affairs
(UNDESA).
From
2016,
Nina
was
appointed
as
Adviser
to
the
Secretary
-
General’s
Special
Represe
ntative,
Ms.
Louise
Arbour,
during
the
European
refugee
crisis
to
develop
the
“Global
Compact
for
Migration”,
the
first
ever
globally
agreed
policy
framework
on
global
collaboration
on
migration
and
refugee
movements.
Her
field
missions
with
the
UN
took
he
r
to
West
Africa
to
hold
workshops
on
the
relevance
of
globally
comparable
migration
statistics
to
shape
effective
policies
on
migration.</p>
<p>
Nina
started
her
career
at
the
Swiss
business
federation
in
2008
where
she
she
co
-
founded
the
Swiss
chapter
of
the
UN
Global
Compact
initiative
–
the
largest
corporate
social
responsibility
initiative
–
launched
by
former
UN
Secretary
-
General
Kofi
Annan
in
2000.</p>
<p>
Nina
Hälg
holds
a
MA
degree
in
international
Affairs
and
Governance
from
the
University
of
St.
Gallen,
Switze
rland,
a
BA
in
Political
Economy
and
English
from
the
University
of
Zurich,
Switzerland
and
an
Executive
Degree
on
Digital
Transformation
&
Leadership
from
the
INSEAD
Management
School.</p>`
    },{
        name: `SOLVEIGH HIERONIMUS`,
        index: 26,
        description: `<p>
        Solveigh
Hieronimus
is
a
Senior
Partner
at
McKinsey
&
Company,
based
in
Germany.
She
serves
clients
across
heavily
regulated
industries
such
as
energy,
infrastructure
and
finance
on
topics
covering
digital
and
data
strategies,
sustainability,
and
innovation/growth.
Solveigh
is
als
o
a
member
of
both
McKinsey's
Sustainability
and
People
&
Organizational
Performance
Practices
and
serves
on
the
council
of
the
McKinsey
Global
Institute
(MGI),
where
she
focuses
her
work
on
the
competitiveness
and
long
-
term
prosperity
of
Europe.</p>
<p>Solveigh
is
a
Young
Global
Leader
(YGL)
at
the
World
Economic
Forum,
a
member
of
the
Trilateral
Commission
and
the
European
Commission's
high
-
level
expert
panel
for
the
Future
of
Work.
She
is
also
a
regular
panelist
and
speaker
at
international
fora
such
as
the
OE
CD,
DLD
and
the
Chatham
House
Conference.</p>
<p>
Prior
to
joining
McKinsey,
she
held
various
positions
at
the
United
Nations,
Goldman
Sachs
and
JPMorgan.
Solveigh
studied
in
Oxford,
Madrid
and
Paris
and
has
a
M.Sc.
in
Economics
and
a
Diplôme
de
Grande
Ecole
from
ESCP
-
EAP
European
School
of
Management.
In
addition,
she
holds
a
Master
in
Public
Administration
(MPA)
with
focus
on
Public
Finance,
Development
Economics
and
Security
Policy
from
Columbia
University
in
New
York.
</p>
`
    },{
        name: `JOSU JON IMAZ`,
        index: 27,
        description: `<p>
        Josu
Jon
Imaz
has
been
chief
executive
officer
since
April
2014.
Ever
since,
he
has
led
Repsol's
transformation
process,
which
has
established
itself
today
as
a
global
multi
-
energy
company,
a
major
player
in
the
Spanish
electricity
and
gas
market,
an
d
a
leader
in
the
development
of
sustainable
mobility
solutions
that
boasts
one
of
the
most
efficient
refining
systems
in
Europe.
Under
his
leadership,
Repsol
has
accelerated
its
assets'
decarbonization
process
with
the
aim
of
leading
the
energy
transition
.
In
2019,
it
became
the
world's
first
company
in
its
sector
to
commit
to
reaching
net
zero
emissions
by
2050.
        </p>
        <p>
        In
2008,
Josu
Jon
Imaz
joined
Repsol
as
chairman
of
its
subsidiary
Petronor,
a
company
where
he
successfully
managed
the
challenges
of
moderniza
tion,
sustainability,
and
community
relations.
        </p>
        <p>
        In
2012,
he
joined
the
Executive
Committee
as
executive
managing
director
of
the
Industrial
Area
and
New
Energies,
where
he
was
responsible
for
coordinating
the
activities
at
all
the
industrial
complexes,
am
ong
other
functions.
He
was
also
vice
chairman
of
Gas
Natural
SDG,
S.A.
from
September
2016
to
February
2018.</p>
<p>
Josu
Jon
Imaz
is
a
Doctor
of
Chemical
Sciences
from
the
University
of
the
Basque
Country.
He
graduated
from
the
School
of
Chemical
Sciences
in
Sa
n
Sebasti
á
n
and
received
the
award
of
excellence
upon
completion
of
his
degree.
He
was
also
a
research
visitor
fellow
at
Harvard
Kennedy
School
in
the
United
States.</p>
<p>
29
Josu
Jon
Imaz
is
a
Doctor
of
Chemical
Sciences
from
the
University
of
the
Basque
Country.
He
graduated
from
the
School
of
Chemical
Sciences
in
Sa
n
Sebasti
á
n
and
received
the
award
of
excellence
upon
completion
of
his
degree.
He
was
also
a
research
visitor
fellow
at
Harvard
Kennedy
School
in
the
United
States.
He
began
his
career
in
the
field
of
research
upon
being
sent
to
the
French
Technological
Center
(CETIM)
in
Nantes,
as
well
as
in
the
field
of
industrial
(Grupo
Mondrag
ó
n)
and
business
project
promotion
in
connection
with
the
world
of
energy.</p>
<p>
osu
Jon
Imaz
also
held
a
number
of
political
roles,
including
notable
ones
within
the
Ministry
of
Ind
ustry,
Trade,
and
Tourism
of
the
Basque
Regional
Government
from
1999
to
2004.</p>
<p>
He
is
currently
CEO
of
Repsol,
trustee
of
the
Repsol
Foundation,
and
chairman
of
Fundaci
ón
Consejo
España
-
EE.UU.
</p>`
    },{
        name:`SYLVIE KAUFFMANN`,
        index: 29,
        description: `<p>
            Sylvie
Kauffmann
is
a
foreign
affairs
columnist
and
editorial
director
at
the
French
newspaper
Le
Monde.
She
is
also
a
regular
contributor
to
the
opinion
pages
of
the
Financial
Times
and
has
been
a
contributing
writer
for
the
New
York
Times.
        </p>
        <p>
        She
was
the
editor
-
in
-
chief
of
Le
M
onde
in
2010
-
2011.
She
joined
the
newspaper
in
1987
as
Moscow
correspondent.
Since
then,
she
has
been
Eastern
and
Central
Europe
correspondent,
US
correspondent
based
in
Washington
DC,
New
York
Bureau
Chief
and
reporter
-
at
-
large
in
Asia,
based
in
Singapore.
        </p>
        <p>
        29
Josu
Jon
Imaz
is
a
Doctor
of
Chemical
Sciences
from
the
University
of
the
Basque
Country.
He
graduated
from
the
School
of
Chemical
Sciences
in
Sa
n
Sebasti
á
n
and
received
the
award
of
excellence
upon
completion
of
his
degree.
He
was
also
a
research
visitor
fellow
at
Harvard
Kennedy
School
in
the
United
States.
He
began
his
career
in
the
field
of
research
upon
being
sent
to
the
French
Technological
Center
(CETIM)
in
Nantes,
as
well
as
in
the
field
of
industrial
(Grupo
Mondrag
ó
n)
and
business
project
promotion
in
connection
with
the
world
of
energy.
Josu
Jon
Imaz
also
held
a
number
of
political
roles,
including
notable
ones
within
the
Ministry
of
Ind
ustry,
Trade,
and
Tourism
of
the
Basque
Regional
Government
from
1999
to
2004.
He
is
currently
CEO
of
Repsol,
trustee
of
the
Repsol
Foundation,
and
chairman
of
Fundaci
ón
Consejo
España
-
EE.UU.
SYLVIE
KAUFFMANN
Sylvie
Kauffmann
is
a
foreign
affairs
columnist
and
editorial
director
at
the
French
newspaper
Le
Monde.
She
is
also
a
regular
contributor
to
the
opinion
pages
of
the
Financial
Times
and
has
been
a
contributing
writer
for
the
New
York
Times.
She
was
the
editor
-
in
-
chief
of
Le
M
onde
in
2010
-
2011.
She
joined
the
newspaper
in
1987
as
Moscow
correspondent.
Since
then,
she
has
been
Eastern
and
Central
Europe
correspondent,
US
correspondent
based
in
Washington
DC,
New
York
Bureau
Chief
and
reporter
-
at
-
large
in
Asia,
based
in
Singapore
.
Prior
to
joining
Le
Monde,
Sylvie
Kauffmann
worked
for
Agence
France
-
Presse
as
a
foreign
correspondent,
in
London,
New
Caledonia
(South
Pacific),
Warsaw
and
Moscow</p>
<p>
She
graduated
from
Facult
é
de
droit
d'Aix
-
en
-
Provence,
Institut
d'Etudes
Politiques
d'A
ix
-
en
-
Provence,
Universidad
de
Deusto
(Bilbao,
Spain)
and
Centre
de
Formation
des
Journalistes
in
Paris.
Sylvie
Kauffmann
is
the
author
of
“
Les
Aveuglé
s
–
Comment
Paris
et
Berlin
ont
laissé
la
voie
libre
à
la
Russie
”
(2023,
Editions
Stock),
a
book
about
Fr
ance,
Germany
and
Putin
’
s
Russia</p>`,
    },{
        name: `MIA KOVAČIĆ`,
        index: 30,
        description: `<p>
        Mia
Kovačić,
born
in
Belgrade,
is
Director
Communications
at
CWP
Global,
a
world
leader
in
ultra
-
large
-
scale
green
hydrogen
projects.
She
began
her
career
in
the
luxury
industry
in
China
before
dedicating
herself
to
promoting
sustainable
development.
Following
five
years
managing
the
marketing
team
at
Resalta,
the
leading
energy
services
provider
in
Southeast
Europe,
and
a
period
at
La
Farge
Serbia
as
Head
of
Marketing,
Communicat
ions
and
Sustainability,
she
joined
CWP
Global's
hydrogen
business
as
Communications
Director,
covering
the
group’s
ambitious
project
portfolio
of
200+
GW
of
renewable
energy
capacity
across
four
continents.</p>
<p>

30
MIA
KOVA
ČIĆ
Mia
Kovačić,
born
in
Belgrade,
is
Director
Communications
at
CWP
Global,
a
world
leader
in
ultra
-
large
-
scale
green
hydrogen
projects.
She
began
her
career
in
the
luxury
industry
in
China
before
dedicating
herself
to
promoting
sustainable
development.
Following
five
years
managing
the
marketing
team
at
Resalta,
the
leading
energy
services
provider
in
Southeast
Europe,
and
a
period
at
La
Farge
Serbia
as
Head
of
Marketing,
Communicat
ions
and
Sustainability,
she
joined
CWP
Global's
hydrogen
business
as
Communications
Director,
covering
the
group’s
ambitious
project
portfolio
of
200+
GW
of
renewable
energy
capacity
across
four
continents.
Mia
is
a
passionate
advocate
for
finding
real
and
practical
solutions
for
lowering
greenhouse
gas
emissions
and
dedicated
to
ensuring
businesses
and
communities
are
well
prepared
for
the
net
zero
future.</p>
<p>
Educated
in
France
and
China,
she
holds
degrees
in
political
science
and
communications
from
Sci
ences
Po
Paris
and
Fudan
University
and
speaks
five
languages.</p>`
    },{
        name:`MACIEJ KUZIEMSKI`,
        index: 31,
        description: `<p>Maciej
Kuziemski
is
a
CEO
of
PKO
Bank
Polski
Foundation
and
a
Co
-
Founder
of
Philanthropy
for
Impact,
Central
European
initiative
aiming
to
increase
the
region's
democratic
resilience
through
systemic
philanthropy.
Prior
to
that,
Maciej
spent
a
decade
acros
s
public
policy,
academia,
and
social
entrepreneurship.</p>
<p>
He
earned
a
BA
from
University
of
Warsaw
and
MPP
from
University
of
Oxford.
He
is
a
David
Rockefeller
Fellow
at
the
Trilateral
Commission,
a
member
of
the
Technology
and
Democracy
Expert
Group
of
th
e
Stefan
Batory
Foundation,
and
a
board
member
of
Aspen
Institute
Central
Europe,
Coalition
for
Polish
Innovations
and
Harvard
Club
of
Poland.</p>`
    },{
        name:`JEAN LEMIERRE`,
        index: 32,
        description: `<h5>EDUCATION</h5>
        <p>
        Jean
Lemierre
graduated
from
the
Institut
d
’
Etudes
Politiques
(Paris)
and
the
Ecole
Nationale
d
’
Administration.
He
also
holds
a
degree
in
Law.</p>
<h5>CAREER</h5>
<p>Jean
Lemierre
has
a
long
and
recognised
career
in
international
finance.
In
the
1980s
he
held
various
posts
within
the
French
Tax
Administration,
i
ncluding
Head
of
Tax
Legislation
and
Director
General
of
Taxes.
In
May
1995,
he
was
appointed
Chief
of
Cabinet
of
the
French
Ministry
of
Economy
and
Finances
and
become
Head
of
Treasury
in
October
later
that
year.
Before
being
appointed
at
the
helm
of
the
European
Bank
for
Reconstruction
and
Development
in
2000,
he
was
a
member
of
the
European
Monetary
Committee
(1995
-
1998),
President
of
the
European
Economic
and
Financial
Committee
(1999
-
2000)
and
Chairman
of
the
Paris
Club
(1999
-
2000).
He
served
as
Presid
ent
of
the
European
Bank
for
Reconstruction
and
Development
until
2008.
En
2009,
Jean
Lemierre
became
a
member
of
the
International
Advisory
Council
of
the
China
Investment
Corporation
(CIC)
and
the
International
Advisory
Council
of
the
China
Development
B
ank
(CDB).
He
is
member
of
the
International
Advisory
Panel
(IAP)
for
the
Monetary
Authority
of
Singapore
(MAS).
He
was
Senior
Advisor
to
the
Chairman
of
BNP
Paribas
between
1
September
2008
and
30
November
2014.</p>
<h5>TODAY</h5>
<p>
On
1
December
2014,
Jean
Lemierre
became
Chairman
of
BNP
Paribas.
He
is
also
Chairman
of
the
main
French
institute
for
research
into
international
economics
(CEPII),
a
member
of
the
Institute
of
International
Finance
(IIF)
and
in
May
2016,
he
was
elected
Member
of
the
Board
of
Directors
of
TOTAL
Energies.
</p>`
    },{
        name: `BERNARDINO LEÓN`,
        index: 33,
        description: `<p>Bernardino
Le
ó
n
is
a
Spanish
diplomat
and
politician
with
an
extensive
political
and
diplomatic
career.
In
2015
he
was
appointed
Special
Representative
of
the
United
Nations
Secretary
-
General
for
Libya,
where
he
played
a
key
role
in
negotiating
the
Libyan
Political
Agreement,
which
ended
the
civil
war
that
broke
out
in
2014.
Previously,
he
was
the
European
Union's
Special
Representative
for
the
Southern
Mediterranean
(a
position
created
to
deal
wit
h
the
Arab
Spring),
mediating
important
political
processes
in
countries
like
Egypt
and
Tunisia.
He
was
also
posted
to
Algeria
during
the
elections
and
subsequent
internal
conflict
of
the
90s.</p>
<p>
He
was
Secretary
General
at
the
prime
minister
Office,
Secreta
ry
of
State
for
Foreign
Affairs
and
Spanish
representative
in
the
G20,
successfully
negotiating
the
inclusion
of
Spain
in
this
group.
He
was
an
advisor
on
the
Middle
East
peace
process
and
has
been
posted
in
Liberia,
Algeria
and
Greece.
He
was
also
directo
r
of
the
Diplomatic
Academy
of
the
United
Arab
Emirates.
</p>
<p>
He
has
directed
the
Spanish
Moroccan
Three
Cultures
of
the
Mediterranean
Foundation,
and
co
-
founded
with
Daniel
Barenboim
and
Edward
Said
the
Barenboim
-
Said
Foundation,
which
created
the
West
-
Easte
rn
Divan
orchestra
for
young
musicians
from
the
Middle
East.
He
holds
a
degree
in
Law
and
Philosophy,
with
postgraduate
studies
in
Oxford
and
Barcelona.
He
currently
develops
his
academic
activity
at
Sciences
Po
in
Paris,
MedOr
Institute
in
Rome,
IE
Madrid
,
UAE
Diplomatic
Academy,
among
others.
</p>`
    },{
        name: `BO LIDEGAARD`
        ,index: 34,
        description: `<p>Dr.
Bo
Lidegaard
is
an
historian
and
writer,
formerly
a
senior
diplomat
and
international
climate
change
negotiator,
subsequently
editor
in
chief
of
Politiken,
the
leading
Danish
daily.
Today,
Bo
is
co
-
founder
and
partner
at
KayaPartners,
a
policy
advisory
firm
focusing
on
the
intersection
between
politics
and
markets
with
a
focus
on
decarbonisation,
supply
chain
resilience
and
energy.</p>
<p>
Bo
joined
the
Foreign
Service
in
1984
and
served
in
Geneva
and
Paris
before
being
appointed
Head
of
the
Middle
East
and
Latin
America
Department
2003.
2005
-
11
he
served
as
Ambassador,
top
diplomatic
and
national
security
advisor
in
the
Office
of
the
Danis
h
Prime
Minister
where
he
was
also
in
leading
the
political
negotiations
in
the
lead
up
to
the
United
Nations
Climate
Summit
in
Copenhagen
2009.
</p>
<p>
Shortly
after
leaving
public
service,
Bo
became
Editor
-
in
-
Chief
of
Politiken,
the
leading
Danish
daily
2011-16
</p>
<p>
Maintaining
a
personal
network
with
high
-
ranking
officials
throughout
Europe
and
the
US
Bo
then
worked
as
Managing
Director
and
lead
on
EU
and
Climate
Change
with
Macro
Advisory
Partners,
London
2016
-
21.</p>
<p>
In
2021
Bo
co
-
founded
Kaya
Partners
to
pro
vide
high
level,
business
oriented
advise
where
geopolitics
intersect
with
climate
transition,
industrial
policy,
and
green
technology.
Kaya
is
now
established
in
London,
Washington,
Copenhagen
and
Nuuk
advising
major
corporations
and
financial
operators.
</p>
<p>
Alongside
with
his
career
in
public
service
and
as
an
editor,
Bo
has
published
a
more
than
ten
books
on
contemporary
history
and
the
coming
into
being
of
the
modern
welfare
states
in
Northern
Europe.
His
focus
as
a
writer
and
historian
is
on
the
dynamics
between
international
developments
and
domestic
policies
and
the
economy.
He
has
written
several
bestselling
volumes
on
these
themes
and
has
been
awarded
national
and
international
honors.
“
Countrymen
”
,
his
book
on
the
rescue
of
the
Danish
Jews
in
1943,
p
ublished
2014
by
Knopf,
New
York,
has
been
translated
into
12
languages.
</p>`
    },{
        name: `FIONA MAHARG-BRAVO`,
        index: 35,
        description: `<p>
        Fiona
Maharg
Bravo
is
a
partner
at
Brunswick
Group
in
Madrid,
specialising
in
financial
communication.
She
spent
her
early
career
in
London
as
an
analyst
at
JP
Morgan
and
the
European
Bank
for
Reconstruction
and
Development,
followed
by
over
13
years
as
a
financial
columnist
with
Reuters
Breakingviews
in
London
and
Madrid
and
as
a
regular
contributor
on
Spanish
business
for
the
Economist.</p>
<p>
More
recently
she
moved
in
-
house
to
Telefónica
where
she
spent
four
years
as
Director
of
International
and
Financial
C
ommunications.
Fiona
holds
a
BA/MA
in
Political
Science
and
International
Relations
from
the
University
of
Chicago
and
a
diploma
in
Economics
from
the
University
of
Cambridge.
She
is
a
fellow
of
Aspen
Institute
España.
</p>`
    },
    {
        name: `SUSANA MALCORRA`,
        index: 36,
        description: `<p>Ms.
Susana
Malcorra
is
President
and
cofounder
of
GWL
Voices
for
Change
and
Inclusion,
an
NGO
based
in
Madrid
and
dedicated
to
promoting
gender
equality
in
the
multilateral
system.
She
was
the
Dean
of
IE
School
of
Global
&
Public
Affairs
in
Spain.</p>
<p>
Ms.
Mal
corra
served
as
Minister
of
Foreign
Affairs
and
Worship
of
Argentina
(2015
-
2017).
She
was
the
Chef
de
Cabinet
of
the
UN
Secretary
-
General,
Ban
Ki
-
moon.
Before
helding
these
positions,
she
led
the
Department
of
Field
Support
(DFS)
for
Peace
Missions,
based
in
New
York,
as
Under
-
Secretary
General
of
the
United
Nations.
In
2004,
she
joined
the
World
Food
Programme
(WFP)
in
Rome,
as
Assistant
Secretary
General
and
Chief
Operating
Officer
(COO).
</p>
<p>
Ms.
Malcorra
started
her
professional
development
in
IBM
Argentina
.
She
spent
almost
twenty
-
five
years
in
the
private
sector.
From
January
1993
to
2002,
she
worked
in
Telecom
Argentina,
where
she
became
the
Chief
Executive
Officer
(CEO).
</p>
<p>
Ms.
Malcorra
is
an
active
public
speaker,
a
Board
member
in
different
renowned
orga
nizations
such
as
the
United
Nations
Foundation
and
has
received
several
awards
as
a
recognition
for
her
work
and
contribution
to
national
and
international
institutions.
She
is
an
Engineer
and
graduated
from
Universidad
de
Rosario
(Argentina).
</p>`
    },{
        name: `CECILIA MALMSTRÖM`,
        index: 37,
        description: `<p>Cecilia
Malmstr
ö
m
has
worked
almost
20
years
in
the
EU
institutions.
She
was
elected
to
the
European
Parliament
in
1999,
reelected
in
2004
but
left
in
2006
to
serve
as
Minister
of
European
Affairs
in
the
Swedish
governm
ent.
Between
2010
and
2014
she
was
Commissioner
for
Home
affairs
in
the
European
Commission,
Brussels
and
in
2014
-
2019
Commissioner
for
Trade
2014
-
2019.</p>
<p>
From
January
2020
to
December
2021,
she
was
Assar
Gabrielsson
visiting
professor
at
G
ö
teborg
School
of
Economics
at
G
ö
teborg
University,
Sweden.
Cecilia
Malmstr
ö
m
has
a
PhD
in
political
science
and
lectures
regularly
in
different
European
universities
Since
June
2021
Malmstrom
is
a
non
-
resident
senior
fellow
at
PIIE
(Peterson
Institute
for
International
E
conomics),
Washington.</p>
<p>She
also
works
as
a
senior
advisor
at
Lindholmen
Science
Park,
G
ö
teborg.</p>`
    },
    {
        name: "MARIO MONTI",
        description: `<p>
            Senator for life of the Italian Republic, President of Istituto Javotte Bocconi and honorary President of the Institute for European Policy-Making at Bocconi University, having been President of the same university from 1994 to 2022.
        </p>
        <p>
            He was Prime Minister of Italy (2011-2013), heading a government of national unity, which overcame Italy’s sovereign debt crisis and launched structural reforms.
        </p>
        <p>
        Monti had previously served for ten years as Member of the European Commission, in the capacity of Commissioner for the Single Market (1995-1999) and then for Competition (1999-2004).
        </p>
        <p>
        He has been member of several advisory commissions in Italy (e.g. Monti Commission on banking and financial reform, Italian Treasury, 1982), the UK (Roll Committee, 2003), and France (Attali Commission on economic growth in France, 2007). In 2020-2021 he chaired the Pan-European Commission on Health and Sustainable Development, convened by WHO/Europe, and he is currently member of the Lancet Commission on 21st-Century Global Health Threats.
        </p>
        <p>
        At the EU level, he has been the author of A New Strategy for the Single Market (2010), and the Chairman of a High-level Group created by the european institutions that released the report Future Financing of the EU (2017).
        </p>
        <p>
        Monti has been the founding chairman of IGIER, established at Bocconi with CEPR and NBER (1990), and of Bruegel, the European think-tank based in Brussels (2005).
        </p>`,
        index: '37_1'
    },
    {
        name: `MANUEL MUÑIZ`,
        index: 40,
        description: `<p>Manuel
Muñiz
is
the
Provost
of
IE
University
in
Madrid
and
a
Professor
of
Practice
of
International
Relations.
As
Provost
he
is
a
key
contributor
to
IE’s
strategic
development,
and
responsible
for
its
international
expansion
and
strategic
alliances.
Dr.
Muñiz
is
also
the
Dean
of
IE’s
School
of
Politics,
Economics
and
Global
Affairs
(SPEGA).
SPEGA
has
an
internal
a
nd
adjunct
faculty
of
over
100
professors,
and
1,500
students
distributed
across
undergraduate
and
graduate
programs
in
Economics,
Politics,
International
Relations,
and
International
Development.
Currently,
he
is
also
the
Chair
of
the
Board
of
the
IE
New
York
College.
In
June
of
2023
Dr.
Muñiz
was
elected
President
of
the
Association
of
Professional
Schools
of
International
Affairs
(APSIA),
the
preeminent
organization
bringing
together
the
world’s
top
schools
of
global
affairs
and
public
policy.
On
that
s
ame
year
he
was
appointed
a
Senior
Fellow
at
Brookings’
Foreign
Policy
Program.</p>
<p>
From
2020
to
2021
Dr.
Muñiz
was
State
Secretary
(Vice
Minister)
at
the
Spanish
Foreign
Ministry.
In
this
capacity
he
led
the
Strategy
and
Foresight
unit
at
the
Ministry
as
we
ll
as
the
Economic
Diplomacy
team,
and
the
Communications
department,
including
the
Office
for
Diplomatic
Information.
During
this
time,
he
coordinated
the
crafting
of
Spain’s
2021
-
2024
Foreign
Action
Strategy,
and
led
the
work
on
the
National
Strategy
on
Technology
and
Global
Order,
a
document
aimed
at
launching
Spain’s
Technology
Diplomacy.
While
in
office
he
also
coordinated
Spain’s
OECD
Ministerial
Presidency
of
2020
and
was
a
member
of
the
Prime
Minister’s
Covid19
task
force.</p>
<p>From
2015
to
2017
Dr.
Mu
ñiz
was
the
Director
of
the
Program
on
Transatlantic
Relations
at
Harvard
University’s
Weatherhead
Center
for
International
Affairs.
And
from
2017
to
2020
he
was
a
Senior
Associate
at
Harvard's
Belfer
Center
for
Science
and
International
Affairs,
as
well
a
s
one
of
the
promoters
of
its
Project
on
Europe
and
the
Transatlantic
Relationship.</p>
<p>
Dr.
Muñiz’s
academic
work
has
focused
on
the
impact
of
technology
on
social
and
economic
trends.
He
has
studied
the
drivers
behind
the
rise
of
populism
and
its
effects
on
global
affairs.
He
has
written
extensively
about
the
fracturing
of
the
social
contract
in
western
countries
and
the
rise
of
anti
-
elite
and
anti
-
democratic
sentiment.</p>
<p>Dr.
Muniz
holds
a
JD
(Law)
from
the
Complutense
University
in
Madrid,
an
MSc
in
Financi
al
Markets
from
the
IEB,
a
Master’s
in
public
administration
from
Harvard’s
Kennedy
School
of
Government,
and
a
DPhil
(PhD)
in
International
Relations
from
the
University
of
Oxford.
He
is
a
Permanent
Member
of
the
Royal
European
Academy
of
Doctors,
a
memb
er
of
the
Advisory
Committee
of
the
Club
of
Madrid,
a
member
of
the
Board
of
Trustees
of
the
Ortega
-
Marañón
Foundation
and
a
council
member
of
the
European
Council
on
Foreign
Relations.
Lastly,
Dr.
Muñiz
is
a
recipient
of
a
number
of
awards
and
recognition
s
including
the
Trilateral
Commission’s
David
Rockefeller
Fellowship,
the
Körber
Foundation’s
2017
Munich
Young
Leader
Fellowship,
the
Atlantic
Council’s
Millennium
Fellowship,
and
the
Eisenhower
Fellowship.
In
2016
he
was
recognized
by
Esglobal
as
one
of
the
25
intellectuals
having
the
greatest
impact
on
our
thinking
about
Iberoamérica.</p>
`,
    },{
        name: `ANA PALACIO`,
        index: 41,
        description: `<p>Ana
Palacio,
an
international
lawyer
by
training,
was
the
first
female
Minister
of
Foreign
Affairs
of
Spain.
Apart
from
her
long
career
in
public
service
–
from
leading
positions
in
European
institutions
to
the
front
lines
of
the
World
Bank
Group
–
she
has
specialized
in
energy
matters.
Currently,
along
with
leading
Palacio
&
Associates,
the
European
Union
consultancy,
Ms.
Palacio
sits
on
the
corporate
boards
of
several
publicly
-
traded,
energy
-
focused
companies
–
among
them,
Enagás,
the
Spanish
gas
system
o
perator,
where
she
serves
as
the
Lead
Independent
Director
and
Chair
of
the
Sustainability
and
Nomination
Committee
–
and
is
a
member
of
the
International
Advisory
Board
of
OCP
Group
(leading
Moroccan
fertilizer
company).
She
also
serves
on
the
Industry
Ad
visory
Committee
of
the
International
Energy
Forum,
along
with
the
External
Advisory
Committee
of
Secretary
Ernest
Moniz’s
Energy
Futures
Initiative.</p>
<p>
Among
the
positions
she
has
held
in
major
foundations
and
think
tanks,
her
tenure
as
a
member
of
the
Boa
rd
of
Trustees
of
the
Carnegie
Corporation
of
New
York
stands
out.
She
is
also
a
member
of
the
Board
and
the
Strategy
Committee
of
the
Atlantic
Council
and
was
the
first
non
-
American
member
of
its
Executive
Committee.
Ms.
Palacio
is
a
visiting
professor
at
the
Edmund
A.
Walsh
School
of
Foreign
Service
at
Georgetown
University
and
at
the
UM6P
University,
and
she
is
a
member
of
the
governing
bodies
of
several
public
and
academic
institutions.
She
is
a
regular
speaker
at
international
conferences
and
a
contrib
utor
to
different
publications,
including
a
monthly
column
for
Project
Syndicate,
and
a
weekly
column
for
El
Mundo
(Spain).
</p>
<p>
Ms.
Palacio
served
as
a
member
of
the
Executive
Committee
and
Senior
Vice
President
for
International
Affairs
of
Areva,
leader
in
n
uclear
power
and
renewable
energy,
and
she
was
a
member
of
the
International
Advisory
Board
of
Anadarko
Petroleum
Corporation.
</p>
`
    },{
        name: `CLAUDIA PARZANI`,
        index: 42,
        description: `<p>Claudia
Parzani
is
Chair
of
the
Italian
Stock
Exchange,
Deputy
Chair
of
Il
Sole
24
Ore
S.p.A.
and
a
non
-
executive
director
at
Stellantis
N.V.</p>
<p>
Business
lawyer,
specialized
in
corporate
matters
and
corporate
governance,
strategy
and
sustainability,
she
is
a
Senior
Advisor
at
the
global
law
firm
Linklaters,
where
she
was
a
partner
for
many
years
and
covered
key
managerial
roles
at
a
global
level.
S
he
gained
experience
working
with
Italian
and
international
law
firms,
assisting
Italian
and
international
banks
and
corporates
in
the
context
of
the
most
complex
extraordinary
transactions.
She
was
Chair
of
Allianz
S.p.A.,
served
as
an
external
member
of
the
Board
of
Directors
of
the
higher
education
institution
Politecnico
di
Milano
and
covered
the
role
of
non
-
executive
director
for
listed
and
not
listed
companies.</p>
<p>
Always
extremely
passionate
about
inclusion
and
social
matters,
Claudia
is
a
member
of
th
e
advisory
board
of
UNHCR
Italy,
sits
in
the
Comitato
Scientifico
of
Parks
–
Liberi
e
Uguali
and
is
the
Chair
of
the
Strategic
Council
of
Fondazione
Italia
per
il
Dono.
She
is
the
founder
of
“Breakfast@Linklaters”,
a
large
network
of
female
executives,
and
is
the
ambassador
in
Italy
for
the
Inspiring
Girls
campaign
to
promote
inclusion
and
fight
stereotypes.
She
was
Chair
of
Valore
D
and,
together
with
Valore
D
and
other
partners,
she
structured
and
launched
“In
The
Boardroom”,
preparing
women
to
step
into
board
positions.
</p>
<p>
Claudia
is
also
Deputy
Chair
of
the
Italian
group
of
the
Trilateral
Commission
and
a
member
of
some
of
the
most
influential
national
and
international
think
tanks
and
of
some
of
the
main
associations
of
the
Italian
business
community.
S
he
is
often
a
speaker
in
conferences
and
roundtables
on
topics
such
as
corporate
governance,
ESG,
economy
and
finance,
leadership,
future
scenarios,
innovation,
world
of
work,
D&I,
talent,
young
people
and
generations.
</p>
<p>
She
is
the
author
of
articles
and
p
ublications
and
has
contributed
to
various
books.
Together
with
Francesca
Isola
she
co
-
authored
“Meravigliose
Tour
guidato
all’interno
di
noi
stesse”
(Il
Sole
24
Ore,
2020)
dedicated
to
gender
issues
and
female
talent
and
with
Sandro
Catani
she
co
-
authored
“Si
vince
solo
insieme”
(Garzanti,
2022),
on
the
tools
necessary
to
face
future
challenges
in
the
world
of
work.
More
recently,
she
published
“La
rivoluzione
degli
outsider”
(Rizzoli,
2024),
on
the
talent
of
women
and
young
people,
the
importance
of
inclu
ding
genders
and
all
generations
and
changes
in
leadership
models.
</p>
<p>
She
sits
in
many
and
important
juries
and
has
won
multiple
awards
for
her
career
and
her
continuous
social
commitment.
Ranked
as
“Eminent
Practitioner”
by
Chambers
&
Partners,
“Highly
Rega
rded”
and
“Woman
Leader”
by
IFLR
1000
and
included
in
the
Legal500
“Hall
of
Fame”,
she
was
named
in
the
global
HERoes
Women
Role
Model
List
for
eighth
year
in
a
row.
</p>`
    },{
        name: `ALESSANDRO PICCIONI`,
        index: 43,
        description: `
        <p>
        Alessandro
Piccioni
is
a
Fintech
Investor
at
CVC
Capital
Partners.
CVC
is
a
leading
global
alternative
investment
manager
focused
on
private
equity,
secondaries
and
credit
with
a
global
network
of
29
local
offices
and
€188
billion
of
assets
under
managemen
t.
        </p>
        <p>
        Former
SVP
at
Nexi,
leading
player
in
the
European
financial
technology
industry,
Alessandro
has
been
responsible
for
Strategy,
Innovation
and
Business
Development.
Main
areas
of
expertise
and
initiatives
led
include
Open
Banking,
Alternative
Payments,
Blockchain
and
Data
-
driven
products.
More
recently,
he
served
as
CMO
in
the
consumer
business
unit.
        </p>
        <p>
        Prior
to
Nexi,
Alessandro
worked
as
a
management
consultant
at
Bain&Company
in
New
York,
London,
and
Milan
focusing
on
FS,
Media
&
Technology,
and
as
a
po
rtfolio
manager
at
Goldman
Sachs
in
NY
and
Miami.
        </p>
        <p>
        He
also
serves
as
an
Independent
Non
-
Executive
Director
and
Chairman
of
the
Remuneration
and
Nomination
Committee
at
Trevi,
a
world
leader
in
underground
and
soil
engineering
since
2019</p>
<p>
He
is
currently
a
Shareholder
and
Investment
Committee
member
in
the
Venture
Capital
fund
Rancilio
Cube.
As
an
Angel
Investor,
he
is
now
focusing
on
bringing
Artificial
Intelligence
and
Blockchain
innovation
to
traditional
markets,
particularly
in
Sports
and
Healthcare.
</p>
<p>
He
is
passionate
about
financial
markets,
central
bank
policy,
and
geopolitics.
At
the
Madrid
meeting,
I
look
forward
to
discussing
central
banks’
policy
trade
-
offs,
as
well
as
Europe
and
US
evolving
relationship
with
India
and
China.
I
am
also
keen
to
dis
cuss
the
implications
of
GenAI
on
several
industries,
as
we
navigate
the
machine
revolution
and
its
practical
implications.</p>
<p>
He
holds
an
MBA
from
the
Massachusetts
Institute
of
Technology
and
a
Master
of
Science
in
Accounting
and
Finance
from
the
London
Sc
hool
of
Economics.
He
is
currently
a
PhD
Student
in
AI.</p>
<p>
Alessandro
is
originally
from
Perugia,
Italy.
In
his
free
time,
he
enjoys
playing
golf,
motor
racing,
and
traveling
abroad
with
his
wife,
Francesca,
and
children,
Leonardo
and
Lavinia.
</p>`
    },{
        name:  `ANTONIO PONCIONI MERIAN`,
        index: 44,
        description: `<p>A
dual
Brazilian
and
French
citizen,
Antonio
is
a
historian
by
training.
He
currently
serves
as
a
Special
Envoy
to
President
José
Ramos
-
Horta
of
Timor
-
Leste
and
as
the
Advisor
for
International
Relations
to
Prime
Minister
Patrice
T
rovoada
of
São
Tomé
e
Príncipe.
Furthermore,
he
holds
or
has
held
non
-
executive
corporate
roles
with
Consorcio
Nobis
(Ecuador),
Export
Trading
Group
(South
Africa),
Gemcorp
(United
Kingdom),
Lazard
(France)
and
Technobrain
(Kenya).</p>
<p>
Prior
to
that,
Antonio
was
Odebrecht’s
Global
Head
of
Government
Affairs
and
External
Relations
as
well
as
Group
Director
for
Africa,
UAE
and
Portugal.
</p>
<p>
Throughout
his
career,
he
has
advised,
in
different
capacities,
various
governments
and
a
variety
of
international
organization
s
actively
engaged
in
emerging
markets,
and
more
notably
so
in
Sub
-
Saharan
Africa
and
in
Latin
America.
</p>
<p>
Educated
at
the
École
Normale
Supérieure,
Sciences
-
Po
(Paris),
the
Sorbonne
and
UC
Berkeley,
Antonio
obtained
an
«
Agrégation
»
and
holds
a
Master
in
P
ublic
Affairs
and
International
Relations
in
addition
to
a
Master
of
Arts
and
a
PhD
in
Latin
American
and
Spanish
Studies.
</p>
<p>
Antonio
is
a
Trustee
of
the
World
Law
Foundation,
an
Advisory
Board
member
of
Politique
Internationale,
the
Instituto
Pedro
Pires
par
a
a
Liderança
(Cabo
Verde),
Fundación
Global
Democracia
y
Desarrollo
(Dominican
Republic),
Semanos
Humanos
(Colombia),
and
the
OECD’s
Emerging
Network.
He
is
also
a
Goodwill
Ambassador
for
the
Foundation
Lindau
Nobel
Laureate
Meetings
(Germany)
and
a
Comma
nder
(R)
in
the
French
Navy.
</p>
<p>
Additionally,
he
is
a
member
of
the
Trilateral
Commission
(David
Rockefeller
Fellow),
the
B20
Infrastructure
and
Investment
Taskforce,
the
B20
Anti
-
Corruption
Forum,
The
Royal
Institute
of
International
Affairs,
the
Club
XXI
e
Siècle,
the
African
Leadership
Network,
the
Automobile
Club
de
France,
Grémio
Literário
and
Annabel’s.
</p>`,
    },{
        name: `JULIA REUSS`,
        index: 45,
        description: `<p>Director
Public
Policy
Central
Europe,
Meta.</p>
<p>ulia
Reuss
joined
Meta
in
February
2021
and
is
responsible
for
the
company’
s
regulatory
affairs
and
policy
-
and
innovation
strategy
in
32
Central
European
countries.
The
region
includes
the
BeNeLux
countries,
Germany,
Austria
and
Switzerland,
as
well
as
23
countries
in Central
and
Eastern
Europe
and
Russia.
Julia
Reuss
previously
held
various
management
positions
in
Germany’s
federal
administration.
Her
positions
led
from
the
German
Bundestag
to
the
Federal
Ministry
of
Transport
and
the
Federal
Chancellery.
Julia
Reuss
was
responsible
for
international
strategic
business
developme
nt
for
Deutsche
Bahn
and
represented
the
group
in
Paris
for
four
years.</p>
<p>
Julia
Reuss
studied
political
science
in
Vienna,
Washington
D.C.
and
Berlin
and
holds
a
PhD
from
the
Free
University
of
Berlin.</p>
`
    },{
        name: `JACOBO ROA-VICENS`,
        index: 46,
        description: `<p>Jacobo
Roa
-
Vicens
is
a
Spanish
investment
banker
and
artificial
intelligence
researcher.
He
is
currently
an
Executive
Director
and
Head
of
Product
&
Business
Development
at
the
JPMorganChase
Machine
Learning
Center
of
Excellence.
He
previously
covered
syst
ematic
macro
trading
strategies
and
strategic
corporate
derivatives,
as
well
as
fixed
income
markets
at
Morgan
Stanley.</p>
<p>
Meanwhile,
Jacobo
conducts
research
in
applied
artificial
intelligence
at
University
College
London,
focused
on
new
models
of
statistic
al
machine
learning,
including
applications
as
a</p>
<p>
Research
Associate
at
the
UCL
Centre
for
Blockchain
Technologies.
He
earned
his
degree
of
Electrical
Engineer
at
Universidad
Politécnica
de
Madrid,
his
PhD
in
Machine
Learning
at
University
College
London,
a
MSc
in
Management
from
HEC
Paris
(Diplôme
Grande
École)
and
a
MA
in
Economics
from
the
College
of
Europe
in
Belgium,
in
addition
to
courses
at
École
Polytechnique
in
France
and
Harvard
University
in
the
US.</p>
<p>
Jacobo
has
received
excellence
awards
and
fello
wships
from
the
Lucent
Technologies
Foundation
and
the
Spanish
Ministry
of
Foreign
Affairs,
among
others.
He
has
a
deep
interest
in
disruptive
technologies,
international
economics
and
public
affairs,
having
served
as
member
of
the
National
Scholar
Council
of
the
Spanish
Ministry
of
Education
and
Science,
advising
on
legislation,
and
as
David
Rockefeller
Fellow
and
Country
Secretary
of
the
Trilateral
Commission.
A
passionate
scuba
diver,
he
qualified
as
professional
scuba
diving
instructor.</p>`
    },{
        name: `FRANCESCO ROCCHETTI`,
        index: 47,
        description: `<p>Francesco
Rocchetti
is
the
Secretary
General
of
ISPI
(Italian
Institute
for
International
Political
Studies),
an
independent,
non
-
partisan,
non
-
profit
think
tank,
and
the
Curator
of
the
Rome
MED
Dialogues,
a
leading
conferen
ce
on
the
Mediterranean
and
the
Middle
East.</p>
<p>Previously,
he
conducted
research
on
geoeconomics
and
international
trade
and
led
the
ISPI
communication
team.</p>
<p>
Before
joining
ISPI,
he
held
positions
at
the
European
Parliament
and
the
OECD.
He
studied
at
the
University
of
Milan
and
Sciences
Po
Paris.
</p>
<p>
He
is
the
co
-
host
of
“
Globally
“,
the
most
popular
Italian
podcast
on
international
affairs.</p>`
    },{
        name: `PAOLO SCARONI`,
        index: 48,
        description: `<p>
        Paolo
Scaroni
is
Chairman
of
Enel,
Chairman
of
Giuliani
Pharmaceuticals,
Chairman
of
AC
Milan
and
Chairman
of
Sicura.
He
is
also
Professor
(on
contract)
at
Bocconi
University
in
the
Master
of
Energy
Transition
and
Energy
Geopolitics.
Paolo
Scaroni
graduated
in
Economics
from
L.
Bocconi
University
in
Milan
in
1969
and
speaks
four
languages.
He
began
his
career
at
Chevron
(1969
-
1971).
After
obtaining
a
Master's
degree
in
Business
Administration
from
Columbia
Universit
y
in
New
York
in
1972,
he
joined
McKinsey
&
Co.
as
a
consultant
(1972
-
1973).
In
1973,
Paolo
Scaroni
joined
Saint
Gobain,
where
he
held
various
management
positions
in
Italy
(1973
-
1978),
Latin
America
(1978
-
1983)
and
Paris
(1984
-
1985).</p>
<p>
From
1985
to
199
6
he
was
Managing
Director
of
Techint.
From
May
1997
to
May
2002,
he
was
Managing
Director
of
Pilkington
in
London
(world
leader
in
flat
glass
production).
From
May
2002
to
May
2005
he
was
Chief
Executive
Officer
of
Enel.
From
May
2005
to
May
2014
he
was
Chief
Executive
Officer
of
Eni.
From
May
2014
to
May
2023
he
was
Deputy
Chairman
of
the
Rothschild
Group.
</p>`
    },{
        name: `AMANDA SLOAT`,
        index: 49,
        description: `<p>Dr.
Amanda
Sloat
served
most
recently
as
Special
Assistant
to
President
Biden
and
Senior
Director
for
Europe
at
the
U.S.
National
Security
Council.
Before
joining
the
Biden
-
Harris
Administration,
she
was
the
Robert
Bosch
Senior
Fellow
at
the
Brookings
Institution.
She
was
also
a
non
-
resident
fellow
in
the
Project
on
Europe
and
the
Transatlantic
Relationshi
p
at
Harvard
Kennedy
School's
Belfer
Center,
as
well
as
a
senior
advisor
at
the
Albright
Stonebridge
Group.</p>
<p>
Dr.
Sloat
previously
served
in
the
U.S.
government
for
nearly
a
decade.
During
the
Obama
Administration,
she
was
Deputy
Assistant
Secretary
for
Southern
Europe
and
Eastern
Mediterranean
Affairs
at
the
State
Department.
She
also
served
as
Senior
Advisor
to
the
White
House
Coordinator
for
the
Middle
East,
North
Africa
and
Gulf
Region,
as
well
as
Senior
Advisor
to
the
Assistant
Secretary
of
State
for
European
and
Eurasian
Affairs.
In
addition,
she
was
a
Senior
Professional
Staff
Member
on
the
U.S.
House
of
Representatives
Foreign
Affairs
Committee,
with
responsibility
for
European
policy.
</p>
<p>
Prior
to
her
government
service,
Dr.
Sloat
was
a
Senior
Program
Officer
with
the
National
Democratic
Institute
(NDI),
including
work
in
Iraq
with
the
Council
of
Representatives.
She
was
a
post
-
doctoral
research
fellow
with
the
Institute
of
Governance
at
Queen's
University
Belfast.
During
this
time,
she
held
visiting
f
ellowships
at
the
Academy
of
Sciences
in
the
Czech
Republic,
United
Nations
Research
Institute
for
Social
Development,
and
the
Jean
Monnet
Center
at
New
York
University
Law
School.
She
also
served
as
a
special
advisor
to
the
Scottish
Parliament,
Northern
I
reland
Assembly,
and
European
Commission.
Dr.
Sloat
holds
a
PhD
in
Politics
from
the
University
of
Edinburgh
and
a
BA
in
Political
Theory
from
James
Madison
College
at
Michigan
State
University.
She
has
published
a
book
(Scotland
in
Europe:
A
Study
of
Mult
i
-
Level
Governance)
and
numerous
articles
on
European
politics.
</p>`
    },{
        name: `ELAINE SMITH GENSER`
        ,index: 50,
        description: `<p>Elaine
Smith
Genser
has
over
three
decades
of
financial
leadership
experience,
with
the
last
thirteen
years
focused
on
mobilizing
private
sector
resources
for
global
institutions,
including
the
United
Nations,
World
Bank,
and
World
Economic
Forum.
Her
expertise
lies
in
financial
and
capital
markets,
multilateral
stakeholder
engagement,
and
sustainable
finance.
Elaine
has
also
served
on
the
boards
o
f
directors
for
both
non
-
profit
organizations
and
private
foundations,
including
on
finance
and
investment
committees.
She
is
the
first
Independent
Trustee
and
Non
-
Executive
Director
of
Anglo
American
(LSE:
AAL)
Foundation,
in
both
UK
and
South
Africa,
bei
ng
also
a
Member
of
its
Finance
and
Investment
Committee.</p>
<p>
Elaine
currently
runs
partnership
initiatives
for
the
United
Nations
Joint
Sustainable
Development
Goals
(SDG)
Fund,
an
organization
created
by
the
UN
Secretary
-
General
to
blend
$1
billion
annually
from
governments
with
private
sector
investments
to
accelerate
implementation
of
the
2030
Agenda.
In
her
current
capacity,
she
leads
a
team
in
structuring
and
allocating
resources
to
several
UN
agency
impact
projects.
Earlier
in
her
career,
Elaine
had
tra
ding
and
research
sales
management
roles
at
global
investment
banks,
including
Goldman
Sachs,
Morgan
Stanley,
and
J.P.
Morgan,
where
she
supervised
on
average
25
professionals
and
managed
daily
trading
volumes
ranging
from
$75
million
to
$250
million.
Elai
ne
brings
deep
and
substantive
expertise
in
structuring
innovative
public
-
private
partnerships,
crafting
</p>
<p>
sustainability
strategies
for
business
models,
and
enhancing
governance
and
accountability
in
cross
-
border
transactions
within
developing
markets.
Whil
e
at
the
World
Economic
Forum,
Elaine
managed
the
Global
Future
Council
of
Financial
and
Monetary
Systems,
collaborating
with
top
S&P100
institutions.
She
also
played
a
key
role
in
designing
the
agenda
for
international
gatherings
of
banking
and
exchange
C
EOs
alongside
public
authorities.
Elaine's
career
trajectory
reflects
her
early
recognition
of
the
importance
of
integrating
social
responsibility,
sustainability,
and
environmental
considerations
into
the
strategies
of
both
public
and
private
enterprises.
</p>
<p>
Elaine
is
a
graduate
of
Harvard
Business
School's
Owner/President
Management
Program
(OPM)
and
holds
an
MBA
from
the
University
of
São
Paulo
-
FIA,
as
well
as
a
BBA
from
Mackenzie
University.
She
has
completed
executive
programs
in
leadership
at
Harvard
Un
iversity's
John
F.
Kennedy
School
of
Government,
Yale
School
of
Management,
Stanford
University,
and
Saïd
Business
School
at
Oxford
University.
Fluent
in
English,
Portuguese,
Spanish,
and
French,
she
also
possesses
a
working
knowledge
of
Italian.
Originall
y
from
Brazil,
she
also
holds
U.S.
and
Italian
citizenship.
In
2013,
Elaine
was
honored
as
a
Young
Global
Leader
(YGL)
by
the
World
Economic
Forum.
She
is
a
Responsible
Leader
of
the
BMW
Foundation
and
a
Member
of
the
Global
Impact
Leaders
at
the
Sorenson
Impact
Center.
</p>
`
    },{
        name: `JAVIER SOLANA`,
        index: 51,
        description: `<p>Javier
Solana
is
one
of
the
world
’
s
most
prominent
diplomats
and
one
of
the
most
significant
political
figures
in
the
international
arena
for
his
vital
role
in
the
development
of
international
relations
for
over
t
wo
decades.
Javier
Solana
is
president
of
ESADE
Center
for
Global
Economy
and
Geopolitics,
where
he
focuses
on
the
evolution
of
the
global
society
and
study
the
global
economy.</p>
<p>
He
is
distinguished
fellow
in
Foreign
Policy
at
Brookings
Institution,
senior
fellow
at
the
Hertie
School
of
Governance
(Berlin),
chairman
of
the
Aspen
Institute
Spain,
and
advisor
to
the
Institute
of
Modern
International
Relations
of
Tsinghua
University.
Javier
Solana
is
also
member
of
the
board
of
the
International
Crisis
Group,
t
he
European
Council
on
Foreign
Relations,
as
well
as
visiting
professor
at
the
London
School
of
Economics,
where
he
was
awarded
an
Honorary
Degree
in
December
2010.</p>
<p>
Solana
was
first
elected
to
the
Spanish
Parliament
in
1977.
Between
1982
and
1995,
he
held
several
cabinet
posts
in
four
governments
headed
by
Spanish
Prime
Minister
Felipe
Gonzalez.
In
July
1992,
Solana
became
minister
of
foreign
affairs,
a
post
he
held
until
1995
when
he
was
named
Secretary
General
of
the
North
Atlantic
Treaty
Organization
(N
ATO).
In
October
1999,
Solana
left
NATO
to
become
Secretary
General
of
the
</p>
<p>
Council
of
the
European
Union
(EU)
and
its
first
High
Representative
for
Common
Foreign
and
Security
Policy,
position
that
he
held
until
December
2009
</p>
<p>
From
2003
to
2009,
Solana
was
the
EU
head
negotiator
for
the
negotiations
with
Iran
on
its
nuclear
program.
He
was
also
the
EU
representative
in
the
negotiations
of
the
Middle
East
Quartet.
During
his
office,
the
EU
had
in
place
over
20
missions
and
operations
in
conflict
areas.</p>
<p>I
n
2019
he
was
unanimously
elected
President
of
the
Royal
Board
of
Trustees
of
the
Prado
Museum.
A
member
since
2009,
he
becomes
the
10th
President
of
the
Board
of
Trustees
of
the
Prado
Museum
since
1980,
when
the
body,
originally
created
in
1912,
was
reconstituted.</p>`
    },{
        name: `CARLOS TORRES VILA`,
        index: 53,
        description: `<p>Carlos
graduated
with
a
B.S.
in
Electrical
Engineering
and
a
B.S.
in
Management
from
the
Massachusetts
Institute
of
Techn
ology,
where
he
later
also
earned
a
M.S.
at
the
MIT
Sloan
School
of
Management.
He
also
graduated
in
Law
from
UNED
(Spain).</p>
<p>He
was
a
Partner
at
McKinsey
&
Company,
where
he
worked
for
12
years.
He
joined
Endesa
in
2002
as
Corporate
Director
of
Strategy
an
d
member
of
its
Executive
Committee,
and
became
company
CFO
in
2007.</p>
<p>In
September
2008,
Carlos
joined
BBVA
as
Head
of
Strategy
and
Corporate
Development,
and
member
of
the
bank's
Management
Committee.
In
March
2014
he
was
appointed
Head
of
Digital
Banking
,
until
May
2015
when
he
became
Chief
Executive
Officer
of
the
bank.</p>
<p>Carlos
was
appointed
Chair
of
BBVA
and
of
the
BBVA
Foundation
in
December
2018.</p>
<p>
He
is
a
member
of
the
Board
of
Directors
of
the
Institute
of
International
Finance
(IIF),
the
International
Business
Council
(IBC)
of
the
World
Economic
Forum,
the
European
Financial
Services
Roundtable
(EFR),
within
it
he
chairs
the
European
Banking
Group,
and
the
Institut
International
d'Études
Bancaires
(IIEB).
He
also
represents
BBVA
at
the
Int
ernational
Monetary
Conference
(IMC).</p>
<p>He
is
a
member
of
several
non
-
for
-
profit
organizations
that
support
entrepreneurship
and
innovation,
such
as
the
Board
of
Trustees
of
Endeavor
Spain,
Fundación
Cotec
or
Círculo
de
Empresarios
Vascos.
In
the
same
way,
he
represents
BBVA
several
non
-
for
-
profit
organizations
that
support
social,
educational,
cultural
and
scientific
activities,
among
which
stand
out
Museo
Nacional
del
Prado,
Fundación
Princesa
de
Asturias,
Fundación
Carolina
or
Fundación
Real
Instituto
Elcano.</p>`
    }, {
        name: `ANDREAS TREICHL`,
        index: 54,
        description: `<p>
        Andreas
Treichl
studied
economics
at
the
University
of
Vienna.
Right
after
achieving
his
master
’
s
degree
he
moved
to
New
York
and
started
a
career
as
a
corporate
banking
officer
with
Chase
Manhattan
Bank.
Over
a
time
span
of
18
years,
he
worked
for
Chase
in
New
York,
Vienna,
Brussels
and
Athens.</p>
<p>
In
1994
he
joined
Erste,
a
small
Viennese
savings
bank,
and
became
its
CEO
in
1997.
In
the
same
year
he
took
the
savings
bank
public.
Over
the
course
of
ten
years
and
thr
ough
various
acquisitions,
he
turned
Erste
Group
into
the
largest
retail
bank
in
Central
Europe,
growing
its
client
base
from
600,000
to
over
16
million
people
in
Austria,
the
Czech
Republic,
Slovakia,
Hungary,
Romania,
Croatia
and
other
Western
Balkan
countries.</p>
<p>
In
2003
Andreas
founded
ERSTE
Foundation,
which
is
Erste
Group
’
s
core
shareholder.
He
became
ERSTE
Foundation
’
s
chairman
in
2020.
The
foundation
uses
the
dividends
it
receives
to
foster
the
region
’
s
prosperity
and
strengthen
its
democracy
by
creating
the
social,
economic,
and
cultural
infrastructure
and
innovation
for
a
changing
Europe.
In
2006
he
founded
“
Die
Zweite
”
,
a
savings
bank
for
the
unbanked,
and
expanded
the
foundation
’
s
network
in
the
CEE
region.
</p>
<p>
Erste
Group,
ERSTE
Foundation
and
“
Die
Zweite
”
all
live
up
to
the
principles
the
founding
fathers
of
the
first
savings
bank
had
set
in
1819:
No
age,
no
gender,
no
social
standing,
no
nation
shall
be
excluded
from
the
benefits
that
the
Spar
-
Casse
offers
every
depositor.
Andreas
is
continuously
working
on
translating
this
principle
into
the
reality
of
the
21st
century.
His
future
focus
will
be
on
turning
around
the
slow
descent
of
the
European
middle
class.</p>
<p>
Andreas
serves
as
chair
of
Die
Zweite,
v
ice
chair
of
the
Vienna
Opera,
the
Vienna
based
Central
European
University
’
s
Board
of
Trustees,
the
Foundation
for
Economic
Literacy
and
other
organisations.
From
2020
to
summer
2024,
he
was
the
president
of
the
European
Forum
Alpbach.
Established
right
a
fter
the
end
of
the
Second
World
War,
it
is
dedicated
to
bring together
young
people
from
all
over
Europe
with
the
brightest
minds
from
politics,
business,
science,
culture
and
civil
society
to
work
on
Europe’s
future.
</p>
<p>
Andreas
invests
in
start
-
up
enterprises
dedicated
to
financial
well
-
being.
</p>`,
    },{
        name: `LEVENT TUZUN`,
        index: 55,
        description: `<p>Levent
Tuzun
is
a
Principal
II
at
the
European
Bank
for
Reconstruction
and
Development
(EBRD)
in
London,
UK.
He
focuses
on
investments,
technical
cooperation
and
policy
dialogue
w
ith
clients
and
policymakers
in
financial
services
and
capital
markets.
His
work
also
spans
projects
that
relate
to
the
EBRD’s
focus
on
digital
transition
in
its
countries
of
operation,
including
fintech
and
supply
chain
financing.
Previously,
Levent
worke
d
in
investment
banking
at
J.P.
Morgan
in
New
York.</p>
<p>
He
was
a
Weidenfeld
-
Chevening
Scholar
at
the
University
of
Oxford
and
completed
the
Master
of
Public
Policy
(MPP)
degree
at
the
Blavatnik
School
of
Government.
He
graduated
from
Yale
University
with
unde
rgraduate
degrees
in
Economics
and
International
Studies,
and
completed
the
Brady
-
Johnson
Program
in
Grand
Strategy.</p>
<p>
Levent
is
a
David
Rockefeller
Fellow
(DRF)
and
the
current
elected
European
Fellows’
Representative
at
the
Trilateral
Commission.
He
has
been
recognized
as
a
Millennium
Fellow
at
the
Atlantic
Council,
Goldman
Sachs
Global
Leader
and
Fellow
at
the
Observer
Research
Foundation’s
Asian
Forum
on
Global
Governance
(AFGG).
</p>
`,
    },{
        name: `ALEX VANOPSLAGH`,
        index: 56,
        description: `<p>Born
in
1991
in
France
to
a
Danish
mother
and
a
French
father,
Alex
Vanopslagh
moved
to
Denmark
at
a
young
age
and
spent
his
youth
in
Struer
in
Western
Jutland.
After
enrolling
in
political
science
studies
at
the
University
of
Southern
Denmark
and
moving
to
Odense
Alex
engaged
him
self
in
the
Youth
of
the
Liberal
Alliance,
rising
through
the
ranks
to
become
national
leader
in
2014
-
2016
and
seeing
the
organization
reach
new
heights
of
membership
numbers
and
presence
in
national
media.</p>
<p>
Shortly
thereafter
Alex
became
the
leader
of
the
Liberal
Alliance
in
capital
municipality
of
Copenhagen
and
managed
to
buck
the
national
trend
of
significant
losses
in
the
2017
local
elections.
In
the
meantime,
Alex
also
worked
as
a
public
affairs
consultant
from
his
graduation
until
his
unexpected
elec
tion
to
the
national
parliament,
the
Folketing,
in
2019,
representing
the
West
Jutland
constituency.
</p>
<p>
The
2019
Folketing
election
saw
the
Liberal
Alliance
lose
9
seats
out
of
13
and
only
barely
make
it
over
the
representation
threshold
of
2
%
of
the
votes.
The
incumbent
leader
did
not
achieve
reelection
and
thus
Alex
took
over
the
mantle
of
national
leader
at
the
age
of
27.
After
a
very
rocky
start,
Alex
headed
an
effort
to
rebuild
the
party
with
a
strong
emphasis
on
classical
liberalism,
personal
responsib
ility
and
an
attempt
to
use
innovative
methods
and
styles
in
messaging.
This
effort
paid
off
in
the
2022
Folketing
elections
which
saw
the
Liberal
Alliance
achieve
its
best
result
yet
at
7,9
%
of
the
votes
and
14
seats.
</p>
<p>
With
an
unusual
unity
government
in
place
between
the
former
archenemies
of
the
center
-
left
and
center
-
right,
Alex
now
heads
one
of
the
largest
opposition
parties
in
the
Folketinget.
Aside
from
his
post
as
leader
of
the
Liberal
Alliance,
Alex
is
a
member
of
the
Foreign
Policy
Committee
of
t
he
Danish
Parliament.
</p>
<p>
Alex
is
the
father
of
a
school
aged
son
and
lives
with
his
girlfriend
in
Copenhagen.
He
dabbles
in
fine
wines
and
good
literature.</p>
`
    },{
        name: `LESLIE VINJAMURI`,
        index: 57,
        description: `<p>Dr
Leslie
Vinjamuri
is
director
of
the
US
and
Americas
programme
at
Chatham
House
and
professor
of
international
relations
at
SOAS
University
of
London.
She
is
chair
of
the
faculty
of
the
Queen
Elizabeth
II
Academy
at
Chatham
House
(from
2018
-
2024,
she
was
Dean
of
the
Academy).</p>
<p>
Leslie
leads
research
initiatives
on
America’s
Changing
Global
Role,
Reimagining
Multilateralism,
and
the
US,
Geopolitics,
and
the
Global
South.
She
is
the
author
most
recently
of
‘Why
Multilateralism
Still
Matters’
(Foreign
Affairs).
</p>
<p>
She
led
the
research
initiative
and
was
a
contributing
author
to
Building
Global
Prosperity:
Proposals
for
Sustainable
Growth
(Chatham
House,
2022).
She
is
co
-
editor
and
contributing
author
(with
Charles
A.
Kupchan)
of
Anchoring
the
World:
International
Order
in
the
21
st
Century,
a
publication
by
members
of
the
Lloyd
George
Study
Group
on
World
Order,
a
joint
Centenary
project
of
Chatham
House,
the
Council
on
Foreign
Relations,
and
Georgetown
University’s
School
of
Foreign
Service,
published
by
Foreign
Affairs.
And
also
Human
Rights
Futures
(with
Jack
Snyder
and
Stephen
Hopgood,
Cambridge
University
Press,
2017),
US
Foreign
Policy
Priorities
(Chatham
House,
2020),
and
‘Trials
and
Errors:
Strategies
of
International
Justice’
(with
Jack
Snyder).
</p>
<p>
Her
publications
have
also
appeared
in
numerous
edit
ed
volumes
and
journals
including
Foreign
Affairs,
Foreign
Policy,
International
Security,
Ethics
and
International
Affairs,
and
Survival.
</p>
<p>
She
is
a
regular
commentator
in
the
international
news
media
and
has
contributed
pieces
in
the
Financial
Times,
Guar
dian,
Sunday
Times,
Telegraph,
and
The
Independent.
Leslie
is
vice
chair
of
the
Carnegie
Council
for
Ethics
and
International
Affairs,
and
deputy
chair
of
the
Marshall
Aid
Commemoration
Commission.
</p>
<p>
She
is
a
life
member
of
the
Council
on
Foreign
Relations
,
and
on
the
Advisory
Board
of
LSE
IDEAS
and
the
LSE
Phelan
United
States
Centre
and
is
vice
president
of
the
board
for
the
Institute
for
Integrated
Transitions.
</p>
<p>
From
2014
-
16
she
was
director
of
the
Center
on
Conflict,
Rights
and
Justice
(and
previously
c
o
-
director).
She
was
previously
on
the
academic
faculty
of
Georgetown
University’s
School
of
Foreign
Service,
and
a
fellow
of
the
John
M.
Olin
Institute
at
Harvard
University.
</p>
<p>
She
began
her
career
at
Congressional
Research
Service
and
also
worked
in
the
As
ia
Bureau
at
USAID.
Leslie
received
a
BA
from
Wesleyan
University
(Phi
Beta
Kappa),
an
MSc
(Distinction)
from
the
London
School
of
Economics,
and
a
PhD
from
Columbia
University.
</p>
`
    },{
        name: `AXEL WEBER`,
        index: 58,
        description: `<p>Axel
Weber
is
President
of
the
Center
for
Financial
Studies
at
Goethe
University
Frankfurt.
He
is
the
Chairman
of
the
Trilateral
Commission
Europe
and
a
member
of
the
Group
of
Thirty.</p>
<p>
He
is
the
Chairman
of
the
Advisory
Board
of
the
Visa
Economic
Empowerment
Institute.
He
also
chairs
the
Advisory
Boards
of
CVC
Advisers
Limited
and
Raisin
GmbH.
Furthermore,
he
is
global
a
senior
global
advisor
of
Boston
Consulting
Group
and
advises
the
Se
nior
Management
of
Flossbach
von
Storch
AG
</p>
<p>
From
2012
to
2022,
Axel
Weber
served
as
the
Chairman
of
the
Board
of
Directors
of
UBS
Group
AG.
He
was
also
Chairman
of
the
Board
of
Directors
of
the
Institute
of
International
Finance
</p>
<p>
Prof.
Weber
was
the
Pres
ident
of
the
Deutsche
Bundesbank
(2004
-
2011)
and
served
as
a
Member
of
the
Governing
Council
of
the
European
Central
Bank,
Member
of
the
Board
of
Directors
of
the
Bank
for
International
Settlements,
German
Governor
of
the
International
Monetary
Fund
and
wa
s
a
member
of
the
G7
and
G20
Ministers
and
Governors.
He
was
a
member
of
the
steering
committees
of
the
European
Systemic
Risk
Board
(2011)
and
the
Financial
Stability
Board
(2010
-
2011).</p>
<p>
He
was
Visiting
Professor
at
the
University
of
Chicago
Booth
School
o
f
Business
(2011
-
2012)
and
Professor
of
International
Economics
at
the
University
of
Cologne
(2001
-
2004).
He
also
served
as
a
Member
of
the
German
Council
of
Economic
Experts
(2002
-
2004).
Before
that,
he
was
Professor
of
Monetary
Economics
and
Director
of
the
Center
for
Financial
Studies
at
Goethe
University
in
Frankfurt
(1998
-
2001).
He
was
also
Professor
of
Economic
Theory
at
the
University
of
Bonn
(1994
-
1998).
</p>
<p>
Axel
Weber
holds
a
PhD
in
economics
from
the
University
of
Siegen.
He
graduated
with
a
master
’
s
degree
in
economics
at
the
University
of
Constance
and
holds
honorary
doctorates
from
the
universities
of
Duisburg
-
Essen
and
Constance.</p>
`,
    },{
        name: `MARTIN WEISS`,
        index: 38,
        description: `<p>Martin
Weiss
is
currently
Managing
Director
of
Viscal
Capital,
an
investment
vehicle
focused
on
disruptive
digital
technologies
with
a
focus
on
artificial
intelligence.</p>
<p>
Previously,
Martin
was
the
CEO
of
German
media
Group
Hubert
Burda
Media,
founder
of
i
nvestment
fund
BurdaPrincipal
Investments
where
he
led
the
investment
in
four
unicorns;
CEO
and
co
-
founder
of
strategy
consulting
firm
Solon
(now
AltmanSolon)
and
EVP
at
NASDAQ
-
listed
Millicom.</p>
<p>
A
long
-
time
expert
in
digital
media
and
communications,
he
has
been
board
member
at
Vinted
Ltd.,
the
world’s
largest
marketplace
for
secondhand
clothes,
HolidayCheck
AG,
Germany’s
leading
packaged
holidays
group,
and
Chairman
of
Frankfurt
-
listed
jobs
platform
New
Work
SE.
Martin
holds
a
B.Sc.
(Econ)
from
the
Londo
n
School
of
Economics
and
a
Master
in
Public
Administration
from
the
Harvard
Kennedy
School.
He
is
married
with
three
children
and
lives
in
Munich
and
London.</p>
`
    },
    {
        name: `JOSÉ LUIS MARTÍNEZ ALMEIDA`,
        index: 39,
        description: `
        <p>
            Mayor
of
the
city
of
Madrid
        </p>
        <p>
        He
holds
a
degree
in
Law
from
the
Universidad
Pontificia
de
Comillas
(ICADE).
Before
entering
politics,
he
worked
as
a
state
lawyer,
which
allowed
him
to
play
different
roles
in
the
public
administration.
        </p>
        <p>
        Among
the
prominent
positions
he
has
held,
he
was
Director
General
of
Historical
Heritage
of
the
Community
of
Madrid
between
2007
and
2011,
Secretary
of
the
Governing
Council
of
the
Community
of
Madrid
between
2011
and
2013,
and
Secretary
General
and
of
the
Council
of
Sepides
between
2023
and
2014.
        </p>
        <p>
        n
2
015,
he
was
elected
councillor
in
the
Madrid
City
Council,
and
in
April
2017
he
was
appointed
spokesperson
of
the
Municipal
Group
of
the
Partido
Popular
in
the
City
Council.
After
the
municipal
elections
of
May
2019,
Mart
í
nez
-
Almeida
was
sworn
in
as
mayor
of
Madrid,
a
position
he
currently
holds.
        </p>
        `,
    },{
        name: `RAFAEL YUSTE`,
        index: 59,
        description: `
        <p>
        Rafael
Yuste,
M.D.,
Ph.D,
is
a
neuroscientist
that
studies
the
cerebral
cortex
at
Columbia
University,
where
he
is
Professor
of
Biological
Sciences.
Yuste
obtained
his
M.D.
at
the
Universidad
Autónoma
in
Madrid.
After
working
in
Nobel
Laurate
Sydney
Brenner's
laboratory
at
the
Medical
Research
Council
in
Cambridge,
UK,
he
was
a
Ph.D.
student
in
Nobel
Laurate
Torsten
Wiesel’s
laboratory
at
Rockefeller
University
in
New
York,
and
a
postdoctoral
student
at
AT&T
Bell
Laboratories.
He
joined
Columbia
in
1996
and
is
currently
director
of
its
Neurotechnology
Center.</p>
<p>
Yuste
and
his
students
pioneered
the
development
of
many
imaging
techniques
in
neuroscience,
such
as
calcium
imaging
of
neuronal
circuits,
two
-
photon
imaging
of
spines
and
circuits,
photostimulation
using
inorganic
caged
compounds,
two
-
photon
op
togenetics
and
holographic
microscopy.
He
led
the
researchers
who
proposed
the
US
BRAIN
Initiative,
and
helped
launch
the
International
BRAIN
Initiative.</p>
<p>
He
also
led
the
“Morningside”
group
of
25
researchers
and
clinicians
who
proposed
novel
human
rights
(“Neurorights”)
to
protect
brain
activity
and
brain
data.
He
has
obtained
awards
from
the
Mayor
of
New
York
City,
the
Society
for
Neuroscience,
the
Director
of
the
U.S.
National
Institutes
of
Health
and
the
Tällberg/Eliasson
Global
Leadership
Prize.
</p>`
    },
    ]);

    const moveElementByIndexToFront = (targetIndex) => {
        const foundIndex = speakers.findIndex(obj => obj.index === targetIndex);
        
        if (foundIndex !== -1) {
            const [element] = speakers.splice(foundIndex, 1);
            speakers.unshift(element);
        }
        
        return speakers;
    }

    useEffect(() => {
        setSpeakers(moveElementByIndexToFront(51));
        setSpeakers(moveElementByIndexToFront(39));
        setSpeakers(moveElementByIndexToFront(12));
    }, []);
    
    return (
        <div className={"dashboard"}>
        <Header back={true}/>
        {
            <>
            {
                (speaker)?
                <div className={(speaker && speaker.name) ? "pop-up blur h-100 w-100" : 'pop-up z-index-negatif'} onClick={()=>{setSpeaker({index: speaker.index})}}>
                
                </div>
                :
                ''
            }
            <h2 className="mt-5 text-center">
            Speakers
            </h2>
            {
                (loading)?
                <h1 className="mt-5 text-center">
                Loading...
                </h1>
                :
                ''
            }
            <div className="pop-up-container position-fixed" style={(speaker && speaker.name) ? {opacity: 1, zIndex: 20} : {opacity: 0, zIndex: -5}}>
            <button onClick={()=>{setSpeaker({index: speaker.index})}} className="p-1 btn-speaker">
            X
            </button>
            <img 
            src={(speaker) ? `./assets/speakers/speaker${(speaker.index)}.png` : ''} 
            onError={(e) => e.target.src = './assets/speakers/default.jpg'} 
            width="100%" 
            height="auto" 
            alt={(speaker) ? `Image of ${speaker.name}` : ''}
            />
            <h3 dangerouslySetInnerHTML={(speaker) ? {__html: speaker.name} : {__html: ''}} className="text-center mt-3">
            </h3>
            <p className="mt-3" dangerouslySetInnerHTML={{__html: (speaker) ? speaker.description : ''}}></p>
            </div>
            <div className="container mt-3" style={(loading) ? {opacity: 0} : {opacity: 1}}>
                <div className="row">
                {
                    speakers.map((speaker, index) => {
                        const defaultImage = './assets/speakers/default.jpg';
                        const speakerImage = `./assets/speakers/speaker${(speaker.index)}.png`;
                        
                        return (
                            <div key={speaker.index} className="col col-4 p-3">
                            <div className="speaker-card c-p" onClick={()=>{setSpeaker({...speaker, index: (speaker.index)})}}>
                            <div className="image-container">
                            <img
                            onError={(e) => e.target.src = defaultImage}
                            src={speakerImage}
                            width="100%" 
                            height="auto" 
                            alt={`Image of ${speaker.name}`}
                            />
                            </div>
                            <h4 dangerouslySetInnerHTML={{__html: speaker.name}} className="text-center fs-1em mt-3 mb-3">
                            
                            </h4>
                            </div>
                            </div>
                        );
                    })                
                }
                </div>
            </div>
            </>
        }
        <FooterPartenerCommun/>
        </div>
    );
}